import Locale from 'element-ui/lib/locale/lang/de.js' // 引入element语言包
const de = {
  login: {
    name: '',
    page: '',
    lanuage: 'Sprache',
    text: 'Anmeldung mit E-Mail',
    text2: 'Anmeldung mit Code',
    email: 'E-Mail-Adresse',
    placeholdername: 'E-Mail-Adresse',
    placeholderemail: 'Bitte geben Sie Ihre E-Mail Adresse ein',
    emailformate: 'Falsches E-Mail-Format',
    placeholderpsw: 'Kennwort',
    login: 'Anmeldung',
    account: 'Erinnern',
    password: 'Passwort merken',
    rememberPhone: 'Telefon merken',
    getCode: 'Senden',
    register: 'Registrieren',
    passwords: 'Kennwort vergessen?',
    pswr: 'Bitte geben Sie Ihr Kennwort ein',
    emailr: 'Verifizierungs-Code',
    phone: 'Einloggen mit Telefon',
    phoneplace: 'Bitte geben Sie Ihre Telefonnummer ein',
    phoneerror: 'Falsches Format',
    phoneverify: 'Verifizierungs-Code',
    countryTitle: 'Land/Region',
    tokenError: 'Login-Timeout!',
    accountDisabled: 'Konto deaktiviert!',
    userNotActivated: 'Konto ist nicht aktiviert！',
    userFrozen: 'Das Konto wurde gesperrt',
    tryAgain: 'versuchen Sie es später erneut',
    validPhoneNumber: 'Bitte geben Sie eine gültige Telefonnummer ein',
    simplifiedChinese: 'Vereinfachtes Chinesisch'
  },
  sync: {
    overflow: 'Überlauf',
    manle: `Die Szenenkapazität dieses Geräts ist erreicht, eine Teilnahme an Szene [abc] ist nicht möglich. Um eine neue Szene zu nutzen, löschen Sie bitte zuerst vorhandene Szenen und klicken Sie dann auf 【 Wiederholen 】.`,
    data: 'Startzeit',
    areaname: 'Bereich',
    time: 'Zeit',
    identification: 'Identifizieren',
    retry: 'Wiederholen',
    delete: 'Löschen',
    synchronizing: 'Synchronisierung',
    cousreTitle: 'Daten synchronisieren',
    background: 'Im Hintergrund laufen lassen',
    allTry: 'Alle wiederholen',
    info: 'Info',
    alltry: 'Alle wiederholen',
    close: 'Abbrechen',
    area: 'Bereich',
    scene: 'Schauplatz',
    ifttt: 'Automatisierung',
    config: 'Konfigurieren Sie',
    projectId: 'Projekt-ID',
    constIllumination: 'Tageslichtsteuerung',
    rhythm: 'Zeitplan'
  },
  sylogs: {
    dataControlTip: 'Es werden nur Daten für drei Monate dargestellt',
    dataControlTip1: 'Zeige nur die letzten 50 Einträge an. Wechsle das Datum, um Daten für einen bestimmten Tag anzuzeigen',
    infor: 'Info',
    warning: 'Achtung',
    error: 'Fehler',
    to: 'An',
    startdate: 'Startzeit',
    enddate: 'Endzeit',
    plhode2: 'Ebene',
    plhode3: 'Name',
    plhode4: 'EreignisID',
    plhode5: 'Einzelheiten',
    search: 'Suche',
    out: 'Exportieren',
    dates: 'Datum',
    lever: 'Ebene',
    id: 'Cloud-ID',
    name: 'Name',
    EventID: 'EreignisID',
    detail: 'Einzelheiten',
    waring: 'Geräteadressenkonflikt',
    all: 'Alle',
    downfiletip: 'Datei wird exportiert, bitte warten...',
    systemModuleName: 'Relevante Funktion',
    userActionTypeName: 'Aktion Typ',
    urlPath: 'Pfad',
    arguments: 'Argumente',
    callResultCode: 'Ergebnis',
    uCloudId: 'Cloud-ID',
    ipAddress: 'IP',
    success: 'Erfolgreich',
    fail: 'Fehlgeschlagen',
    datapickerLimit: 'Die maximale Exportdauer beträgt 1 Monat, bitte passen Sie Ihre Einstellungen an.',
    allEvent: 'Alle Ereignisse'
  },
  failureLogs: {
    dates: 'Uhrzeit melden',
    id: 'Cloud-Geräte-ID',
    name: 'Gerätename',
    area: 'Bereich',
    failure: 'Fehlerzustand',
    operation: 'Betrieb',
    failureRemind: 'Fehlalarm',
    time: 'Zeit',
    go: 'Details prüfen'
  },
  otaUpdate: {
    customTime: 'Benutzerdefinierter Zeitplan',
    notStarting: 'Manuelle Ausführung',
    name: 'Gerät',
    type: 'Typ',
    online: 'Online',
    Update: 'Aktualisieren',
    caozuo: 'Aufgabe',
    update: 'Upgrade',
    know: 'Identifizieren Sie',
    stop: 'Anhalten',
    tab1: 'Alle',
    tab2: 'Upgrade erforderlich',
    tab3: 'Aufrüstung',
    tab4: 'Erfolg',
    tab5: 'Fehlgeschlagen',
    offline: 'Offline',
    identification: 'Identifizieren Sie',
    upgrade: 'Aktualisieren',
    initiatefail: 'Scheitern',
    ingfail: 'Fehlgeschlagen',
    success: 'Erfolg',
    warninginfor: 'Keine',
    waitForupgrade: 'Warten auf Upgrade',
    Upgradeing: 'Aktualisieren von',
    UpgradeSuccess: 'Upgrade erfolgreich',
    UpgradeDuplicate: 'Dupliziert',
    UpgradeFail: 'Gescheitert',
    UpgradeConfilct: 'Konflikt aufgetreten!',
    UpgradeBusy: 'Besetzt',
    UpgradeProjectIdNull: 'Keine Projekt-ID',
    info: 'Info',
    stopfail: 'Fehlgeschlagen',
    stopsuccess: 'Erfolg',
    wakeUpDeviceAndUpgrade: 'Wecken Sie das Gerät wie unten beschrieben auf und klicken Sie dann auf „Jetzt upgraden“, um das Update abzuschließen',
    webMeshOtaNotSupported: 'Die aktuelle Bluetooth-Firmware unterstützt kein Web Mesh OTA; bitte App-GATT-Upgrade verwenden',
    upgradeNow: 'Jetzt upgraden',
    automaticUpgrade: 'Automatisches Upgrade'
  },
  addThirdDevice: {
    addgateway: 'Eine Smart Connect Box hinzufügen',
    span: 'Fügen Sie ein Gerät eines Drittanbieters hinzu',
    step1: 'Smart Connect Box auswählen',
    step2: 'COM auswählen',
    step3: 'Gerätetyp',
    save: 'speichern',
    back: 'Zurück',
    productKey: 'Alle Zeichenfolgen des QR-Codes'
  },
  addVirtualGateway: {
    next: 'Weiter',
    previous: 'Zurück',
    devicename: 'Gerät',
    writedevicename: 'Name des Geräts',
    span: 'Smart Connect Box hinzufügen',
    step1: '1.Den Typ auswählen',
    step2: '2.Info eingeben',
    header: 'Typ auswählen',
    typewarning: 'Typ auswählen',
    success: 'Erfolg',
    error: 'Fehlgeschlagen',
    confiminfor: 'Das Gerät war in einem anderen Projekt, sind Sie sicher, dass Sie fortfahren wollen?',
    notice: 'Hinweis',
    sure: 'Sicher',
    back: 'Zurück',
    cancle: 'Abbrechen'
  },
  forgetpsw: {
    account: 'E-Mail-Adresse',
    password: 'Kennwort',
    surepassword: 'Bestätigen Sie Ihr Kenwort',
    emailr: 'Bitte geben Sie Ihren Bestätigungscode ein',
    yanzhneg: 'Code',
    placeholderemail: 'Bitte geben Sie Ihre E-Mail Adresse ein',
    placeholderpsw: 'Bitte geben Sie Ihr Kenwort ein',
    placeholderpswagain: 'Bitte geben Sie Ihr Kenwort erneut ein',
    name: 'Intelligentes Beleuchtungsprojekt',
    setnewpsw: 'Kenwort setzen',
    setpsw: 'Kenwort finden',
    agree: 'Lesen und akzeptieren Sie die Bedingungen',
    ok: 'beenden',
    moredpsw: 'Bitte geben Sie Ihr Kenwort ein',
    passnosame: 'Das Kenwort stimmt nicht überein',
    pswr2: 'Bitte verwenden Sie 6-15 Zahlen und Buchstaben',
    emailformate: 'Falsches E-Mail-Format',
    userLive: 'Benutzer Live',
    userOff: 'Benutzer Aus'
  },
  findGateway: {
    next: 'Nächste',
    previous: 'Zurück',
    devicename: 'Gerät',
    suredevice: 'Bestätigen',
    countdown: 'Zählen',
    '120s': 'Bitte klicken Sie auf die Schaltfläche "Bestätigen" auf der Smart Connect Box, wie in der Abbildung oben gezeigt, und dann auf "Weiter".',
    g2Confirm: 'Bitte klicken Sie auf die Schaltfläche "Bestätigen" auf der Smart Connect Box, wie in der Abbildung oben gezeigt, und dann auf "Weiter".',
    mac: 'MAC-Adresse',
    macplaceholder: 'Bitte geben Sie die MAC-Adresse ein',
    scanning: 'Scannen Sie den QR-Code',
    infor1: 'Setzen Sie das Gerät zurück, und verbinden Sie es mit dem Internet',
    infor2: 'Bitte geben Sie die MAC-Adresse ein',
    span: 'Smart Connect Box hinzufügen',
    step1: '1. Wählen Sie den Typ der Smart Connect Box',
    step2: '2. Folgen Sie den Anweisungen und setzen Sie die Smart Connect Box zurück',
    step3: '3. Weisen Sie Ihre Smart Connect Box zu',
    step4: '4. Bestätigen Sie .',
    step5: '5. Smart Connect Box suchen',
    step6: 'Sie können immer noch auf die Schaltfläche der Verbindungsbox drücken, um sie mit dem Netzwerk zu verbinden, falls Sie sie einfach vergessen haben.',
    header: 'Smart Connect Box-Typ auswählen',
    typewarning: 'Smart Connect Box-Typ auswählen',
    macwarning: 'Bitte geben Sie die MAC-Adresse ein',
    success: 'Erfolgreiche Suche',
    error: 'Suche fehlgeschlagen',
    confiminfor: 'Diese Smart Connect Box existiert bereits im aktuellen Projekt. Möchten Sie fortfahren?',
    notice: 'Hinweis',
    sure: 'Weiter',
    back: 'Zurück',
    cancle: 'Abbrechen',
    macerror: 'Falsches Format, bitte überprüfen Sie Ihre MAC-Adresse erneut',
    textHeader: 'Werkseinstellungen und Netzwerk wiederherstellen',
    textOne: 'Reset die Smart Connect Box, indem Sie die Reset-Taste an der Seite drücken.',
    textTwo: 'Reset die Smart Connect Box, indem Sie die Reset-Taste an der Seite drücken.',
    textThree: 'Das grüne ON/OFF-Symbol beginnt zu blinken.',
    textfour: 'Halten Sie die Taste so lange gedrückt, bis alle 3 Symbole an der Oberseite einmal aufgeleuchtet sind. Dies zeigt einen erfolgreichen Reset an.',
    textfive: 'Statische IP,',
    textsix: 'Dann gehen Sie wie folgt vor: Kehren Sie nach Abschluss der Konfiguration über die statische IP-Einrichtung zu dieser Seite zurück.',
    textseven: 'Die Connect Box benötigt einen ungehinderten Internetzugang (eine Firewall kann diesen einschränken). Stellen Sie sicher, dass alle 3 LED-Anzeigen leuchten. Wenden Sie sich bitte immer an die ',
    texteight: 'WLAN',
    texteight1: 'lokale IT-Abteilung ,',
    textnine: 'um zu erfahren, ob Sie die Connect Box auf eine Whitelist setzen müssen.',
    textnine1: 'Wenn eine statische IP erforderlich ist, fahren Sie bitte mit der Einstellung der ',
    textnine2: 'statischen IP fort.',
    staticipsetcaption: 'Statische IP-Einstellungsmethode',
    staticipsetcaption1: 'Die lokale IT-Abteilung muss wissen:',
    staticipsetinfo: 'Statische IP in blau bezieht sich auf das SOP, so wie es jetzt in diesem Schritt funktioniert./nWenden Sie sich im Vorfeld an Ihren IT-Manager und lassen Sie sich die statischen IP-Informationen (IP-Adresse, Subnetzmaske und Standard-Gateway) für die Smart Connect Box geben. /Aktivieren Sie den Bootloader-Modus der Smart Connect Box, um die Kommunikation zu öffnen<br>- Schließen Sie die Smart Connect Box über das Ethernet-Kabel direkt an Ihren Computer an; <br>- Öffnen Sie das Startmenü ➔ PC-Einstellungen ➔ Netzwerk & Internet ➔ Ethernet ➔ Adapteroptionen ändern ➔ Wählen Sie den entsprechenden Ethernet-Anschluss ➔ Doppelklicken Sie, um die Seite mit den Ethernet-Eigenschaften aufzurufen ➔ Doppelklicken Sie auf Internet Protocol Version 4 (TCP/IPv4) ➔ Allgemein ➔ Verwenden Sie die folgende IP-Adresse <br>- Konfigurieren Sie die IP Ihres Computers auf 192. 168.1. X (X kann 2 ~ 254 sein), Subnetzmaske auf 255.255.255.0; Standard-Gateway-IP muss 192.168.1.1 sein, drücken Sie OK, um die Änderungen zu speichern. <br>- Halten Sie die Funktionstaste der Smart Connect Box (die quadratische Taste) 15 Sekunden lang gedrückt, bis die grüne Power-LED-Anzeige blinkt. Dies zeigt an, dass die Smart Connect Box mit dem Bootloader-Programm aktiviert ist. <br>/nÖffnen Sie Ihren Webbrowser und geben Sie 192.168.1.1 ein, um die Webseite der Smart Connect Box aufzurufen;/nIn der Ethernet-Konfiguration ➔ Ändern Sie die IP-Einstellung von DHCP auf Statische IP ➔ Geben Sie die gewünschte IP-Adresse, die Subnetzmaske und das Gateway (vom IT-Manager) ein ➔ Klicken Sie auf Speichern, um die Änderungen zu speichern;/nDrücken Sie die Funktionstaste erneut, um die Smart Connect Box neu zu starten. Die Smart Connect Box verwendet nun die eingestellte statische IP-Adresse.',
    staticipsetinfo5: `Der blau markierte Begriff „Statische IP“ bezieht sich auf die Standardvorgehensweise (SOP), genau wie es derzeit in diesem Schritt der Fall ist./nWenden Sie sich vorab an Ihren IT-Verantwortlichen und lassen Sie sich die für die Smart Connect Box G2 vorgesehenen statischen IP-Daten (IP-Adresse, Subnetzmaske und Standard-Gateway) mitteilen./nVerbinden Sie den LAN-Anschluss des Routers über ein Ethernet-Kabel direkt mit der Smart Connect Box./nRufen Sie die Verwaltungsseite Ihres Routers auf (wenden Sie sich für Zugangsdaten an Ihren IT-Administrator) und suchen Sie die entsprechende IP-Adresse der Smart Connect Box anhand ihrer MAC-Adresse./nÖffnen Sie einen Browser und geben Sie https://[Gateway-IP] ein, um sich beim Smart-Lighting-Websystem anzumelden. Bei der ersten Anmeldung müssen Sie ein Anmeldepasswort festlegen. (Wenn Sie Ihr Passwort vergessen haben, können Sie es mithilfe der Projektinformationen – einschließlich Projektcode, Geräte-Cloud-ID und Geräte-MAC-Adresse – zurücksetzen. Alternativ können Sie die Smart Connect Box G2 durch einen Hardware-Reset auf die Werkseinstellungen zurücksetzen.)/nGehen Sie in der Ethernet-Konfiguration ➔ Ändern Sie die IP-Einstellung von DHCP auf Statische IP ➔ Geben Sie die erforderliche IP-Adresse, Subnetzmaske und das Gateway (vom IT-Manager) ein ➔ Klicken Sie auf „Speichern“, um die Änderungen zu speichern;/nDrücken Sie kurz mit einer Nadel auf die Reset-Taste, um die Smart Connect Box G2 neu zu starten. Die Smart Connect Box verwendet nun die festgelegte statische IP-Adresse.`,
    staticipsetinfo6: `Falls eine Firewall oder ein Sicherheitssystem im Einsatz ist, teilen Sie Ihrem lokalen IT-Team bitte die MAC-Adresse jeder Smart Connect Box G2 mit. Ihr lokales IT-Team wird diese MAC-Adressen auf die Whitelist setzen, was auch dazu beiträgt, Verbindungsprobleme in Zukunft zu vermeiden./n
 Um einen stabilen Betrieb der Smart Connect Box zu gewährleisten, öffnen Sie bitte die Ports 443 (HTTPS) und 8883 (MQTT). Falls der OPPLE-Kundendienst Sie bittet, Protokolle hochzuladen, um bei der Fehlerbehebung zu helfen, müssen Sie zusätzlich Port 80 öffnen. Stellen Sie außerdem sicher, dass der Zugriff auf die Domain iotctrl1.opple.com möglich ist, den von der Smart Connect Box G2 genutzten Cloud-Server.`,
    staticipsetinfo1: 'Wenn eine Firewall/ein Sicherheitssystem vorhanden ist, geben Sie der lokalen IT-Abteilung die MAC-Adresse(n) der Smart Connect Box(s) bekannt. /nDie lokale IT-Abteilung wird die MAC-Adressen auf eine Whitelist setzen, um zukünftige Verbindungsprobleme zu vermeiden. /nWenn die Connect Box-Firmwareversion kleiner als V87.xx.xx ist, öffnen Sie bitte TCP: 80, 443 und UDP: 65501 für das Upgrade. Nach dem Upgrade auf V87.xx.xx wird das Kommunikationsprotokoll automatisch auf TCP: 443 (HTTPS), 8883 (MQTT) geändert. Nach dem Upgrade können Sie TCP: 80 und UDP: 65501 schließen. Port 80 muss für den Abruf von Smart Connect Box-Protokollen aktiviert sein. /nVergewissern Sie sich außerdem, dass der Domänenname iotctrl1.opple.com zulässig ist, da dies der Server/die Cloud ist, mit dem/der die Connect Boxen kommunizieren.',
    finishedDeviceCheck: 'Kästchen ankreuzen, wenn bestätigt',
    notAllowGateway: 'Das Hinzufügen dieses Gateways wird derzeit nicht unterstützt',
    addOnApp: 'Bitte fügen Sie die Konfiguration in der App hinzu',
    deviceInfoError: 'Das Gerät weist einen Defekt auf. Bitte wenden Sie sich an den Installateur oder den OPPLE-Kundendienst, um eine Rücksendung oder einen Austausch zu vereinbaren.',
    g2Tip1: 'Beschreibung der LED-Anzeigen: ①Statusanzeige ②LAN-Anzeige ③Internet-Anzeige ④WLAN-Anzeige',
    g2Tip2: 'Wenn die LAN-Anzeige nicht leuchtet, überprüfen Sie, ob das Netzwerkkabel ordnungsgemäß am Router angeschlossen ist. Wenn Sie im lokalen Netzwerk eine ',
    g2Tip3: 'wenden Sie sich bitte an den IT-Administrator',
    g2Tip4: 'Wenn die Internet-Anzeige nicht leuchtet, überprüfen Sie bitte, ob der Router über einen normalen Internetzugang verfügt, und vergewissern Sie sich, dass die Ethernet- oder WLAN-Anzeigen ordnungsgemäß funktionieren.',
    g2Tip5: 'Wenn Sie im lokalen Netzwerk eine',
    g2Tip9: 'Warten Sie, bis die Statusanzeige, die LAN-Anzeige und die Internetanzeige leuchten, und klicken Sie dann auf „Weiter“.',
    g2Tip10: 'Halten Sie die in der Abbildung gezeigte „Reset“-Taste mindestens 10 Sekunden lang gedrückt, bis die Statusanzeige schnell blinkt, und lassen Sie die Taste dann los. Das Gerät führt einen Werksreset durch. Wenn die Statusanzeige erlischt, war der Reset erfolgreich und das Gerät wird neu gestartet.',
    g2Tip11: 'statische IP-Adresse',
    g2Tip12: 'benötigen, um auf das Internet zuzugreifen, wenden Sie sich bitte an den IT-Administrator.'
  },
  findDevice: {
    addgateway: 'Wählen Sie eine Smart Connect Box aus',
    span: 'Suchen',
    step1: 'Wählen Sie eine Smart Connect Box aus',
    step2: 'Wählen Sie einen Verbindungstyp',
    step3: 'Suchen',
    step4: 'Anhalten',
    child: 'Verbindung',
    progress: 'Fortschritt:',
    save: 'Bestätigen Sie',
    back: 'Zurück',
    warning: 'Wählen Sie einen Verbindungstyp',
    finddevicetotal: 'Geräte scannen Gesamt',
    countdown: 'Scan-Countdown:',
    area: 'Bezirk:',
    areaNo: 'Code',
    areaNoPlaceholder: 'Bitte geben Sie die Vorwahl ein',
    group: 'Gruppe:',
    groupNo: 'Gruppennummer',
    gateway: 'GrantsBay-Tor',
    findDevice: 'Entdecken Sie das Gerät',
    moveAllDevice: 'Standardmäßig werden alle Geräte in den Raum verschoben, unabhängig davon, ob sie eingezogen werden oder nicht？',
    moveAllDeviceTip: 'Wenn du nicht einziehst, kannst du es später in der No-Zone noch einmal tun.',
    notMoveIn: 'Noch nicht eingezogen',
    moveIn: 'Einziehen',
    gatewayName: 'Geben Sie den Gatewaynamen ein',
    selectDevice: 'Bitte wählen Sie ein Gerät aus',
    selectAll: 'Alle auswählen',
    remove: 'entfernen'
  },
  register: {
    account: 'E-Mail-Adresse',
    password: 'Kennwort',
    surepassword: 'Bestätigen Sie Ihr Kenwort erneut',
    name: 'Intelligentes Beleuchtungsprojekt',
    placeholderemail: 'Bitte geben Sie Ihre E-Mail Adresse ein',
    emailformate: 'Falsches E-Mail-Format',
    psw: 'Registrieren',
    regis: 'Registrieren',
    info: '（Als Installateur）',
    address: 'Anschrift',
    phone: 'Telefon-Nummer',
    yanzhneg: 'Verifizierungs-Code',
    finsh: 'Erledigt',
    agreen: 'Lesen und akzeptieren Sie #die Bedingungen',
    placeholderpsw: 'Bitte geben Sie Ihr Kenwort ein',
    moredpsw: 'Bitte geben Sie Ihr Kenwort erneut ein',
    emailr: 'Bitte geben Sie Ihren Verifizierungscode ein',
    pswr2: 'Bitte verwenden Sie 6-15 Zahlen und Buchstaben',
    phoneerror: 'Telefon-Fehler',
    passnosame: 'Das Kenwort ist inkonsistent',
    checkmessage: 'Lesen und akzeptieren Sie die Bedingungen',
    privacy: 'Datenschutz',
    declaration: '(1) Um das intelligente Beleuchtungssteuerungssystem von Opple zu nutzen, muss der Nutzer eine Unternehmens-E-Mail und keine persönliche E-Mail verwenden.<br>(2) Opple sammelt nur die Unternehmens-E-Mail des Nutzers, Systempräferenzen und Produktinformationen.<br>Opple speichert keine persönlichen Daten des Nutzers.<br>(3) Die von Opple gespeicherten Informationen dienen nur dazu, den korrekten Betrieb des intelligenten Beleuchtungssteuerungssystems von Opple zu gewährleisten.<br> (4) Auf Wunsch des Kunden können die von Opple gespeicherten Informationen jederzeit vollständig entfernt werden. <br>(5) Um das Opple Intelligent Lighting Control System nutzen zu können, muss der Nutzer diesen Bedingungen zustimmen.<br> II. Wenn der Benutzer sein Konto über die Funktion "Benutzer kündigen" kündigt, löscht das System<br>alle Informationen, die sich auf dieses Konto beziehen.<br>Zu Punkt (4) benötigt II als Ergänzung',
    existingAccount: 'Bestehendes Konto?',
    countryempty: 'Land/Region Leer'
  },
  header: {
    transProject: 'Projektübergabe',
    exit: 'Beenden',
    projectname: 'Projektname：',
    editmsg: 'bearbeiten.',
    restpsw: 'Das Kenwort zurücksetzen',
    loginOut: 'Abmelden',
    save: 'Speichern',
    cancel: 'Abbrechen',
    language: 'Englisch',
    oldpassword: 'Altes Kenwort',
    newpassword: 'Neues Kenwort',
    confirmpassword: 'Erneut neues Kenwort',
    username: 'Name',
    useraddress: 'Adresse',
    userphone: 'Telefon',
    oldpasswarn: 'Altes Kenwort eingeben',
    newpasswarn: 'Geben Sie das neue Kenwort erneut ein',
    twopasswarn: 'Bitte vergewissern Sie sich, dass Sie die gleichen Passwörter eingegeben haben',
    dosending: 'Senden von',
    switchProject: 'Projekt wechseln',
    logOutUser: 'Aufheben der Registrierung',
    cancelUserTitle: 'Konto abmelden',
    cancelUserOneTips: 'Es gibt nur ein Installationsprogramm für das/die oben genannte(n) Projekt(e). Das Projekt kann nicht wiederhergestellt werden, nachdem es gelöscht wurde. ',
    cancelUserMoreTips: 'Um die Sicherheit Ihres Kontos zu gewährleisten, können Sie die Registrierung Ihres Kontos nur aufheben, wenn keine Projekte in Ihrem Konto vorhanden sind. Bitte löschen Sie die Projekte oder geben Sie sie an andere weiter, bevor Sie die Registrierung aufheben. ',
    cancelUserOneDelTips: 'Für dieses Projekt gibt es nur einen Installer. Das Projekt kann nicht wiederhergestellt werden, nachdem es gelöscht wurde. Sind Sie sicher, dass Sie fortfahren möchten?',
    cancelUserMoreDelTips: 'Nachdem Sie die Registrierung für dieses Projekt aufgehoben haben, können Sie nicht mehr darauf zugreifen. Sind Sie sicher, dass Sie fortfahren möchten?',
    cancelUserOperOneMoreTips: 'Projekte, die noch über Geräte verfügen, können nicht gelöscht, sondern nur übertragen werden. ',
    selected: 'Ausgewählt',
    project: 'Artikel',
    recipientEmail: 'E-Mail des Empfängers:',
    recipientEmailConfirm: 'Bestätigen Sie die E-Mail',
    cancelUser: 'Bestätigen Sie, dass Sie sich wirklich abmelden wollen. Sie können sich nach der Abmeldung nicht mehr anmelden.',
    bindPhoneTitle: 'Verbindliche Bestätigung',
    unbindPhoneTitle: 'Entbindungsbestätigung',
    bindPhoneTips: 'Nach der Bindung können Sie sich mit dem Mobiltelefon anmelden.',
    unbindPhoneTips: 'Nach der Aufhebung der Bindung können Sie sich nicht mehr mit dem Mobiltelefon am Konto anmelden',
    noBindPhoneTips: 'Kein Mobiltelefon',
    noBindEmailTips: 'No Email',
    bindPhoneOpareTips: 'Die Anmeldung mit dem Mobiltelefon wird im Web nicht unterstützt.',
    transferEmail: 'Überweisung an (E-Mail-Adresse)',
    recipientPhone: 'Telefonnummer des Empfängers',
    recipientPhoneConfirm: 'Bestätigen Sie die Telefonnummer',
    setpsw: 'Passwort festlegen',
    bindEmailTips: 'Nachdem die Bindung abgeschlossen ist, können Sie sich mit dieser E-Mail-Adresse bei Ihrem Konto anmelden.',
    unbindEmailTips: 'Nach der Aufhebung der Bindung können Sie diese E-Mail-Adresse nicht mehr für die Anmeldung in Ihrem Konto verwenden.',
    transferPhone: 'Übertragen auf (Telefonnummer)',
    helpTip: 'Hallo, wie kann ich Ihnen helfen?',
    helpDocument: 'Hilfedokumente',
    commonProblem: 'Häufig gestellte Fragen',
    userGuide: 'Benutzerhandbuch',
    problemType: 'Problemkategorien',
    submitter: 'Einreicher',
    submitTime: 'Sendezeit',
    emailFormatMismatch: 'Inkonsistentes E-Mail-Format',
    phoneNumberMismatch: 'Inkonsistente Telefonnummern'
  },
  sidebar: {
    home: 'Startseite',
    details: 'Projekt',
    projectDetails: 'Projekt',
    management: 'Benutzer',
    install: 'Einrichtung',
    monitoring: 'Überwachen',
    control: 'Szene',
    automation: 'Automatisierung',
    systemLog: 'System',
    failureList: 'Störung',
    ota: 'Aufrüstung',
    screen: 'Bildschirm',
    otatask: 'Aktualisieren',
    notices: 'Mitteilung'
  },
  devicelist: {
    treeplaceholder: 'Suche',
    warnmove: 'Gleicher Bereich, bitte wählen Sie einen anderen Bereich aus, in den Sie wechseln möchten.'
  },
  projectList: {
    liteProjectTip: 'Ohne Connect Box System Lite',
    projectNum: 'Projekt intelligente Beleuchtung',
    add: 'Projekt',
    projectApp: 'Klassisches intelligentes Beleuchtungssystem',
    openApp: 'Bitte verwenden Sie die Opple Smart Lighting App, um das Projekt zu öffnen',
    name: 'Name des Projekts',
    time: 'Datum der Erstellung',
    people: 'Installateur(e)',
    state: 'Status',
    num: 'Geräte',
    address: 'Standort',
    UserRole: 'Rolle',
    UserRole1: 'Verwalter',
    UserRole2: 'Installateur',
    UserRole3: 'Verwalter',
    UserRole4: 'Benutzer',
    UserRole5: 'Besucher',
    caozuo: 'Aufgabe',
    in: 'Öffnen',
    all: 'Archivieren',
    modify: 'Ändern',
    accept: 'Annehmen',
    refuse: 'Ablehnen',
    allcountry: 'Alle',
    normal: 'OK',
    malfunction: 'Störung',
    activate: 'Aktivieren',
    delete: 'Löschen',
    good: 'Gut',
    serachWord: 'Name des Projekts',
    fireProject: 'Projekte zur Brandbekämpfung',
    comProject: 'Kommerzielles Projekt',
    standardProject: 'Standardprojekt',
    collection: 'Speichern Sie',
    unCollection: 'Bereits gespeichert',
    continueConfiguring: 'Konfiguration fortsetzen',
    notOperable: 'Nicht in Standardprojektkonfiguration bedienbar'
  },
  projectmsg: {
    storeCode: 'Geschäftscode',
    StoreName: 'Geschäftsname',
    isNo: 'IsNo：',
    placeholder: 'Enter',
    fillChannel: 'Bitte füllen Sie die Kanäle vollständig aus',
    channel: 'Kanäle',
    projectInfo: 'Projektdaten：',
    span1: 'Projekt-Infos',
    span2: 'Projekt-Details',
    name: 'Name des Projekts：',
    type: 'Anwendung：',
    country: 'Land：',
    time: 'Zeitzone：',
    address: 'Anschrift：',
    img: 'Bild：',
    code: 'Postleitzahl：',
    plhode0: 'Projektname ausfüllen',
    plhode1: 'Projektanwendung auswählen',
    plhode2: 'Land/Region ausfüllen',
    plhode3: 'Wählen Sie die Zeitzone des Projekts',
    plhode4: 'Adresse des Projekts ausfüllen',
    plhode5: 'Projekt-Postleitzahl ausfüllen',
    plhode6: 'Projekttyp ausfüllen',
    save: 'Speichern',
    cancel: 'Abbrechen',
    verificationName: 'Bitte geben Sie Ihren Projektnamen ein',
    verificationCountry: 'Bitte wählen Sie Ihr Land',
    verificationType: 'Bitte wählen Sie Ihren Antragstyp',
    verificationAttibute: 'Bitte wählen Sie Ihre Projektart',
    verificationTimeZone: 'Bitte wählen Sie Ihre Zeitzone',
    verificationWorkTime: 'Bitte definieren Sie Ihre Arbeitszeiten.',
    imginfo: 'Größe darf 2 MB nicht überschreiten',
    formateerror: 'Falsches Bildformat, bitte nur jpeg oder png Dateien verwenden',
    bigerror: 'Bildgröße übersteigt 2MB!',
    attribute: 'Projekttyp：',
    ledEnergy: 'LED-Einsparung：',
    ledEnergyTip: 'Bitte geben Sie die LED-Einsparung in Prozent ein',
    everyWorkTime: 'Arbeitsstunden：',
    workStartTime: 'Beginn',
    workEndTime: 'Ende',
    span3: 'Land Info',
    span4: 'Zeitzone Info',
    DST: 'SOMMERZEIT：',
    DSTTime: 'Sommerzeit：',
    DSTTimeTips: 'Bitte wählen Sie Ihre DST-Zeit',
    DSTTimeShift: 'Sommerzeit-Verschiebung：',
    DSTTimeShiftTips: 'Bitte wählen Sie Ihre DST-Verschiebung',
    DSTEnable: 'Aktivieren',
    DSTDisable: 'Deaktivieren',
    to: '-',
    startdate: 'Startzeit',
    enddate: 'Endzeit',
    month: 'M',
    day: 'D',
    countryModifyTips: 'Wenn Sie die Sommerzeitinformationen des Projekts ändern, werden sie mit dem Gerät synchronisiert. Sind Sie sicher, dass Sie sie ändern wollen?',
    timeModifyTips: 'Wenn Sie die Zeitzoneninformationen des Projekts ändern, werden die Informationen mit dem Gerät synchronisiert. Sind Sie sicher, dass Sie sie ändern möchten?',
    modbusDocument: 'Modbus-Datei：',
    Meterdata: 'Angaben der tabelle：',
    ledEnergyError: 'kann nicht >100% sein',
    projectData: 'Projektdaten:',
    exportIn: 'Daten importieren:',
    exportOut: 'Daten exportieren:',
    uploadFile: 'Dateien hochladen',
    downloadFile: 'Brandbekämpfung',
    fireProject: 'Datei herunterladen',
    bacnetDocument: 'BACnet-Datei：',
    programList: 'Programm:',
    errorFileTip: 'Falsches Format, bitte importieren Sie die Datei erneut',
    dataImfo: 'Datennachricht',
    configured: 'Konfiguriert',
    unconfigured: 'Unkonfiguriert',
    holidaysConfiguration: 'Feiertagskonfiguration',
    effectiveImmediately: 'Jetzt anwenden',
    configurationNote: 'Anweisungen zu Feiertagen',
    holidaysConfigurationTip1: 'Feiertage festlegen: Klicken Sie auf ein leeres Datum.',
    holidaysConfigurationTip2: 'Nach dem Klicken auf „Jetzt anwenden“ werden alle Feiertagseinstellungen in allen Automatisierungen (einschließlich bestehender Automatisierungen) aktualisiert!',
    holidaysConfigurationTip3: 'Feiertage löschen: Klicken Sie auf ein Datum, das bereits als Feiertag festgelegt wurde;',
    springFestival: 'Frühlingsfest',
    tombSweepingDay: 'Qingming-Fest',
    laborDay: 'Tag der Arbeit',
    dragonBoatFestival: 'Drachenbootfest',
    midAutumnFestival: 'Mondfest',
    nationalDay: 'Nationalfeiertag',
    newYearsDay: 'Neujahrstag',
    weekEnds: 'Wochenende',
    pleaseClickToConfigure: 'Bitte klicken Sie, um zu konfigurieren',
    anyPointInTime: 'Jeder Zeitpunkt',
    JSONOnly: 'Es dürfen nur Dateien im JSON-Format hochgeladen werden!',
    fileNotExist: 'Datei existiert nicht',
    fileReadFailed: 'Datei konnte nicht gelesen werden',
    jsonFormatError: 'JSON-Formatfehler, bitte überprüfen Sie den Dateiinhalt',
    uploadValidJson: 'Bitte laden Sie eine gültige JSON-Datei hoch',
    resetStandardHolidays: "Auf nationale Feiertage zurücksetzen",
    clearAll: "Alle löschen",
    confirmResetHoliday: "Nach dem Zurücksetzen werden benutzerdefinierte Feiertage gelöscht. Fortfahren?",
    confirmClearAll: "Nach dem Löschen werden alle bestehenden Feiertage gelöscht. Fortfahren?",
    january: "Januar",
    february: "Februar",
    march: "März",
    april: "April",
    may: "Mai",
    june: "Juni",
    july: "Juli",
    august: "August",
    september: "September",
    october: "Oktober",
    november: "November",
    december: "Dezember",
    standardHoliday: "Standard-Feiertage",
    customizeHoliday: "Individuelle Feiertage",
    useStandardHolidayNextYear: "Die üblichen nationalen Feiertage auf das nächste Jahr ausweiten",
    holidayUpdateSubscription: "Abonnieren Sie Benachrichtigungen zu Feiertagsaktualisierungen",
    enterEmailAddress: "Bitte geben Sie Ihre E-Mail-Adresse ein",
    invalidEmailFormat: "Ungültiges E-Mail-Format",
    fetchError: 'Wir können derzeit keine Urlaubsinformationen abrufen. Bitte wenden Sie sich an den Projektmanager/Installateur.',
    isAcknowledged: 'Verstanden',
    countryChangeHoliday: 'Wir möchten Sie daran erinnern, dass die Länderinformationen aktualisiert wurden und es daher hilfreich wäre, die Feiertagskonfiguration innerhalb des Projekts zu überprüfen und zu speichern. Vielen Dank.',
    pleaseSelectAtLeastOneHoliday: 'Bitte wählen Sie mindestens einen Feiertag aus.',
    updatingTheCountry: 'Sollten die Zeitzonenangaben beim Wechsel des Landes automatisch aktualisiert werden?',
    electricityPriceSettings: 'Strompreiseinstellungen',
    pleaseSelectType: 'Bitte Typ auswählen',
    peakHours: 'Spitzenzeit',
    offPeakHours: 'Schwachlastzeit',
    normalHours: 'Normalzeit',
    others: 'Sonstige',
    electricityPrice: 'Strompreis',
    yuanPerKwh: 'CNY/kWh',
    pleaseCompleteTimePeriodInfo: 'Bitte alle Zeitrauminformationen ausfüllen',
    startTimeFormatInvalid: 'Startzeit muss im Format hh:mm sein und darf nicht 24:00 sein',
    endTimeFormatInvalid: 'Endzeit muss im Format hh:mm sein',
    startEndTimeCannotBeSame: 'Start- und Endzeit dürfen nicht identisch sein',
    invalidTimeFormat: 'Ungültiges Zeitformat; bitte hh:mm verwenden',
    invalidTimePeriod: 'Ungültiger Zeitraum; bitte Zeit erneut auswählen',
    timePeriodOverlap: 'Zeiträume überschneiden sich; bitte Zeiten anpassen',
    totalDurationExceeded: 'Gesamtdauer ist 24 Stunden',
    pleaseConfigureTieredPricing: 'Bitte gestaffelte Strompreise konfigurieren',
    ratedPower: 'Nennleistung (W)',
    powerDataConfiguration: 'Leistungsdatenkonfiguration',
    constantLightIntensity: 'Konstante Beleuchtungsstärke',
    pleaseSetLatitudeLongitude: 'Bitte zuerst Breiten- und Längengrad in den Projektdetails festlegen',
    playlistInformation: 'Wiedergabelisteninformationen'
  },
  breadcrumb: {
    sy: 'System',
    home: 'Startseite',
    Project: 'Projektliste',
    Archive: 'Archivierte Projektliste',
    projectMsg: 'Projekt-Infos',
    mangeUsers: 'Benutzerverwaltung',
    addpeople: 'Benutzer hinzufügen',
    systemlog: 'Geräte',
    failureList: 'Störung',
    otaup: 'Aktualisieren',
    deviceinstall: 'Installieren',
    scence: 'Szene',
    device: 'Gerät',
    install: 'Installieren',
    districtmange: 'Bereich',
    devicemange: ' Gerät',
    country: 'Auswählen:',
    adddevice: 'Gerät',
    addtruegateway: 'Smart Connect Box',
    addvirtualdevice: 'Vir-Gerät',
    findDevice: 'Scannen',
    control: 'Steuern',
    monitoring: 'Überwachen',
    ifttt: 'Automatisierung',
    iftttCustomSet: 'Automatisierung Benutzerdefinierter Satz',
    templates: 'Vorlage',
    scenceMsg: 'Szene',
    operatelog: 'Betreiben Sie',
    otaTask: 'Aufgabenliste aktualisieren',
    duplicateArea: 'Bereich duplizieren',
    iftttCustomSetPanel: 'Automatisierung Smart Switch',
    mangeQrcode: 'Freigeben',
    addShare: 'Freigabe hinzufügen',
    mangeLimit: 'Benutzer'
  },
  user: {
    placeholdUserName: 'Bitte geben Sie Ihre Name',
    type1: 'Installateur/Eigentümer',
    type2: 'Leiter',
    type3: 'Benutzer',
    name: ' Name des Benutzers',
    phone: 'Telefon-Nummer',
    address: 'Betrieb',
    state: 'Status',
    caozuo: 'Aufgabe',
    add: 'Hinzufügen',
    sendemail: 'Erneut senden',
    limits: 'Rolle',
    del: 'Löschen',
    info: 'Info',
    deltext: 'Sind Sie sicher, dass Sie löschen möchten?',
    cancel: 'Abbrechen',
    yes: 'Ja',
    status: {
      0: 'Eingeladen',
      1: 'OK',
      2: 'Abgelehnt',
      3: 'Zerstören'
    },
    refuse: 'Sie haben diese Einladung abgelehnt',
    addOne: 'Einen # einladen',
    editInfo: 'Kontoinformationen bearbeiten'
  },
  invite: {
    phoneInvite: 'Per Telefon einladen',
    emailInvite: 'Per E-Mail einladen',
    phonerequired: 'Bitte geben Sie die Telefonnummer des Eingeladenen ein',
    phoneerror: 'Bitte verwenden Sie das richtige Format',
    enterEmailCN: 'Bitte geben Sie die E-Mail-Adresse oder Telefonnummer des Eingeladenen ein',
    inputPassword: 'Passwort eingeben',
    passwordAgain: 'Passwort wiederholen',
    inviteOrCreate: 'Einladen/Erstellen',
    createNewUser: 'Neues Konto erstellen',
    inviteSuccess: 'Eingeladen erfolgreich!',
    createSuccess: 'Erfolgreich erstellt!',
    loginNow: 'Eingeladener kann sich direkt mit diesem Konto anmelden!',
    span: 'Info',
    yaoqing: 'Einladen',
    plhode1: 'Bitte geben Sie die E-Mail-Adresse ein',
    plhode2: 'Bitte geben Sie die Mobiles Telefon ein',
    password: 'Bitte geben Sie das Kenwort ein',
    span1: 'Einladung erfolgreich versendet',
    span2: 'Bitte erinnern Sie die eingeladene Person daran!',
    span3: 'Zurück',
    enterEmail: 'Bitte geben Sie die E-Mail-Adresse ein',
    enterLimite: 'Legen Sie die Rolle fest',
    limiteBlock: 'Bereich',
    finsh: 'Erledigt',
    emailerror: 'Falsches Format',
    emailrequired: 'Bitte geben Sie die E-Mail Adresse ein',
    passwordMismatch: 'Die Passwörter stimmen nicht überein'
  },
  monitor: {
    clickUpdate: 'Klicken Sie zum Hochladen',
    dapingSetting: 'Einstellungen',
    nameSetting: 'Namenseinstellungen',
    backgroundSetting: 'Hintergründeinstellungen',
    serverInfo: 'Server-Informationen',
    haveUsed: 'Verwendet',
    free: 'Leerlauf',
    cpuDetail: 'CPU-Informationen',
    memoryDetail: 'Speicher-Informationen',
    diskDetail: 'Festplatten-Informationen',
    cpuUsedInfo: 'CPU-Nutzung in Echtzeit',
    memoryUsedInfo: 'Echtzeit-Speicherverbrauch',
    showArea: 'Vorderste reihe',
    showTime: 'Zeitleiste',
    DefaultAreaRank: 'Standard-Ranking',
    customSettingRank: 'Benutzerdefiniertes Level-Ranking',
    rankingTitle1: 'Rangliste des Bereichs der Stufe 1',
    rankingTitle2: 'Ebene 2 Bereichsrangliste',
    rankingTitle3: 'Ebene 3 Bereichsrangliste',
    rankingTitle4: 'Ebene 4 Bereichsrangliste',
    saveEnergyRank: 'Ranking Energieeinsparung',
    useEnergyRank: 'Ist-Energie-Ranking',
    showMore: 'Mehr anzeigen',
    curentDay: 'Heute',
    curentWeek: 'Diese Woche',
    curentMonth: 'In diesem Monat',
    curentYear: 'Dieses Jahr',
    curentSeason: 'Dieses Quartal',
    comfort: 'Komfortniveau',
    offline: 'Offline',
    online: 'Online',
    open: 'On',
    close: 'AUS',
    error: 'Störung',
    allcount: 'Geräte',
    lampcount: 'Lampen',
    canup: 'Aktualisieren',
    select: 'Wählen Sie',
    allpower: 'Gesamt-Energieverbrauch',
    allcomfort: 'Umwelt',
    importup: 'Exportieren',
    realtimepowerconsumption: 'Energieverbrauch',
    comparisonofregions: 'Verhältnis',
    selectarea: 'Wählen Sie',
    agriAreaSelect: 'Bereich',
    agriSensorTitle: 'Lichtsensoren',
    agriSensorNatural: 'Natürliches Licht',
    agriSensorUnderLamp: 'Sensor unter Lampe',
    agriNoDataPlease: 'Keine Daten, bitte',
    agriPositionOutside: 'Außen',
    agriPositionRoof: 'Dach',
    agriPositionUnderLamp: 'Unter Lampe',
    agriBindSensor: 'Sensor binden',
    agriRebindSensor: 'Bindung ändern',
    agriUnbindSensor: 'Sensor lösen',
    agriLightStatistics: 'Lichtstatistik',
    agriLampBrightness: 'Lampe Helligkeit',
    agriTodayNaturalLight: 'Heutiges natürliches Licht gesamt',
    agriTodayArtificialLight: 'Heutiges künstliches Licht gesamt',
    agriSupplementDuration: 'Dauer',
    agriTargetProgress: 'Zielfortschritt',
    agriDliTotal: 'DLI Gesamt',
    agriDliNatural: 'Natürliches Licht',
    agriDliArtificial: 'Künstliche Beleuchtung',
    agriSensorNaturalValueLabel: 'Aktueller Lichtwert',
    agriSensorUnderLampValueLabel: 'Momentanes PAR',
    agriToday: 'Heute',
    agriYesterday: 'Gestern',
    agriLastThreeDays: 'Letzte 3 Tage',
    agriLastMonth: 'Letzter Monat',
    agriLastThreeMonths: 'Letzte 3 Monate',
    agriChartNaturalDLI: 'Natürliches Licht kumuliert',
    agriChartArtificialDLI: 'Künstliches Licht kumuliert',
    agriChartTotalDLI: 'Gesamtlicht',
    agriExportLightRecords: 'Lampenbetriebsaufzeichnungen',
    agriExportSensorReport: 'Gebundene Agrarsensordaten',
    agriExportSelectArea: 'Bitte zuerst einen Bereich wählen',
    agriExporting: 'Export läuft, bitte warten…',
    hotspacepic: 'Belegung',
    ranking: 'Belegung in Prozent',
    utilizationrate: 'Belegungsprozentsatz = Bewegungserkennungszeit / Gesamtzeit',
    devicestatus: 'Status',
    sure: 'Bestätigen',
    cancle: 'Abbrechen',
    selectdevicearea: 'Wählen Sie',
    lasthour: 'Letzte 24h',
    lastweek: 'Letzte 7d',
    lastmonth: 'Letzte 30d',
    lastyear: 'Letztes Jahr',
    realtime: 'Echtzeit',
    onehour: 'h',
    warning1: 'Bitte wählen Sie einen Bereich',
    warning2: 'Bitte wählen Sie weniger als 5 Gebiete',
    warning3: 'Bitte wählen Sie die Daten aus',
    warning4: 'Sie können maximal 10 Regionen auswählen',
    warning5: 'Sie können mindestens zwei Regionen auswählen',
    areapowerline: 'Energienutzung',
    time: '',
    spacehottotal: 'Belegung',
    haveperson: 'Besetzt',
    noperson: 'Leer',
    areazline: 'Energieeinsatz',
    powername: 'Energieverbrauch',
    nodata: 'Noch keine gültigen Daten',
    nh: 'Energieverbrauch',
    hotvalue: 'Belegungsindex',
    occupancyActiveButton: 'Belegungsanalyse anzeigen',
    faultDevice: 'Störung(en)',
    systemState: 'Systemzustand',
    systemNormal: 'OK',
    systemDeploy: 'Konfig',
    systemUnusual: 'Fehler',
    systemDeployTips: 'Gerätekonfiguration unvollständig',
    systemUnusualTips: 'Systemfehler wie z.B. defekte Geräte vorhanden',
    choose: 'Wählen Sie',
    realityEnergy: 'Tatsächlicher',
    realityEnergy1: 'Tatsächlicher',
    todayEnergy: 'Heute',
    designEnergy: 'Vorhersage',
    savingEnergy: 'Energieeinsparungs',
    maxEnergy: 'Max',
    minEnergy: 'Min',
    avgEnergy: 'Durchschnitt',
    ledEnergy: 'LED',
    smartEnergy: 'Intelligent',
    ledEnergyRate: 'LED Sparen',
    smartEnergyRate: 'Intelligentes Sparen',
    totalData: 'Armaturenbrett',
    changeEnergy: 'Ändern Sie',
    designEnergyTips: 'Auslegungsenergieverbrauch = Einschaltzeit der einzelnen Lampe × maximale Leistung der einzelnen Lampe.',
    smartEnergyTips: 'Smart Energy Rate = (Auslegungsenergieverbrauch - tatsächlicher Energieverbrauch) / Auslegungsenergieverbrauch.',
    ledEnergyTips: 'LED-Energieeinsparung = (Gesamtleistung der ursprünglichen Lampen - Gesamtleistung der neuen Lampen) / Gesamtleistung der ursprünglichen Lampen.',
    sArea: 'Bereich Verschieben',
    sConfig: 'Gerätekonfiguration',
    sConstillumination: 'Tageslichtsteuerung',
    sIFttt: 'IFttt',
    sProject: 'Projekt-ID',
    sRhythm: 'Zeitplan festlegen ',
    sScene: 'Szene',
    systemTitle: 'Opple: Intelligente Überwachungsplattform für gewerbliche Beleuchtung',
    projectname: 'Projektname',
    projTodayTotalEnergy: 'Gesamtenergieverbrauch (des Projekts heute)',
    dateButtonTxt: 'Bitte wählen Sie angrenzende 2-48 Stunden aus',
    dateButtonTxt1: 'Bitte wählen Sie angrenzende 2-90 Tage aus',
    dateButtonTxt2: 'Bitte wählen Sie angrenzende 2-60 Monate aus',
    dateButtonTxt3: 'Bitte wählen Sie angrenzende 2-30 Jahre aus',
    areaname: 'Bereich',
    areaChoose: 'Wählen Sie 2-10 Bereiche zum Vergleich aus',
    areaContrast: 'Regionaler Energieverbrauchsvergleich',
    hour: 'Std',
    day: 'Tag',
    month: 'Monat',
    year: 'Jahre',
    configYear: 'Jahre',
    configMonth: 'Monat',
    configDay: 'Tag',
    week: 'Wochen',
    energyAll: 'Der gesamte Energieverbrauch',
    accounted: 'Anteil',
    energyRate: 'Energiesparquote',
    designTotalEnergy: 'Entworfen',
    realityTotalEnergy: 'Echt',
    week1: 'Montag',
    week2: 'Dienstag\n',
    week3: 'Mittwoch',
    week4: 'Donnerstag',
    week5: 'Freitag',
    week6: 'Samstag',
    week7: 'Sonntag',
    January: 'Jan.',
    February: 'Feb.',
    March: 'Mär.',
    April: 'Apr.',
    May: 'Mai.',
    June: 'Jun.',
    July: 'Jul.',
    August: 'Aug.',
    September: 'Sep.',
    October: 'Okt.',
    November: 'Nov.',
    December: 'Dez.',
    exportConfirm: 'Export bestätigen',
    enterLimits: 'Bitte geben Sie alle Limits ein',
    gpNoNotempty: 'GpNo kann nicht leer sein',
    selectAreaName: 'Bereichsname auswählen',
    shangHai: 'Shanghai',
    beiJing: 'Peking',
    guangZhou: 'Guangzhou',
    noAreaPermission: 'Die Konfiguration kann nicht abgeschlossen werden, da Ihnen die Bereichsberechtigungen fehlen. Bitte wenden Sie sich an den Administrator, um die erforderlichen Berechtigungen zu erhalten'
  },
  monitorMap: {
    deviceDetail: 'Gerätedetail',
    childDeviceRelation: 'Gerätebeziehung',
    entryIconMonitorMapTip: 'Zum Floorplan-Monitor gehen',
    entryIconMonitorListTip: 'Floorplan-Monitor verlassen',
    equipmentOverview: 'Geräte-Übersicht',
    energyManage: 'Energie-Management',
    spaceUtilization: 'Raumausnutzung',
    openOrClose: 'ein/aus',
    onlineCount: 'Online-Zählung',
    offlineCount: 'Offline-Zählung',
    alarm: 'Warnungen',
    spaceUtilizationShow: 'Anzeige der Platzauslastung',
    spaceUtilizationRank: 'Ranking der Platzauslastung',
    percentageRankDesc: 'Absteigende Reihenfolge nach Prozentsatz',
    spaceMotionShow: 'Demonstration der Platzbelegung',
    spaceMotionDetail: 'Details zur Raumnutzung',
    collapse: 'Falten',
    motionAreaRank: 'Räume sortieren nach belegt/unbelegt',
    switchSpaceUtilizationSuccess: 'Der Grundrissmodus wurde auf Raumnutzung umgestellt!',
    switchSpaceMotionSuccess: 'Der Grundrissmodus wurde auf Raumbelegung umgestellt!',
    totalDay: 'Gesamtbetrag von heute',
    totalMonth: 'Gesamtbetrag für diesen Monat',
    totalYear: 'Gesamtbetrag für dieses Jahr',
    noBindArea: 'Dieser Bereich ist noch nicht gebunden, bitte zeichnen Sie zuerst den Bereich in der Karte und binden Sie diesen Bereich.',
    noCurrentImg: 'Diese Fläche ist nicht in der aktuellen Zeichnung, bitte wechseln Sie zur Zeichnung.',
    min: 'Minimum',
    max: 'Maximal',
    quarterStart: 'Beginn des Quartals',
    quarterEnd: 'Ende des Quartals'
  },
  baoliMap: {
    projectBoard: 'Projekte Übersicht',
    mapMode: 'Grundriss-Modus',
    listMode: 'Listenmodus',
    defaultSort: 'Standard-Ranking',
    warnNumber: 'Gesamt-Warnungen',
    timeEnergy: 'Energie in Echtzeit',
    lightNumber: 'Total Lichter an',
    today: 'Heute',
    nowYear: 'Dieses Jahr',
    LightingRate: 'Prozentsatz der eingeschalteten Lichter',
    entryProject: 'Projekt anzeigen',
    energyConsumption: 'Energie-Monitor',
    deviceNumber: 'Geräte gesamt'
  },
  limite: {
    choose: 'Rolle',
    finsh: 'Erledigt',
    Functional: 'Funktion',
    index: ' Hauptseite (Nicht bearbeitbar)',
    project: 'Projektinfo (Nicht bearbeitbar)',
    monitoring: 'Überwachen',
    lighting: 'Szene',
    areaLimit: 'Bereich',
    movename: 'Bereich',
    onewarn: 'Bitte wählen Sie mindestens einen Bereich aus',
    ifttt: 'Automatisierung',
    qrcode: 'QrCode',
    install: 'Installation',
    failureList: 'Störung',
    waring: 'Der # wird in der Lage sein, Geräte hinzuzufügen, zu löschen, zu verschieben und zu ersetzen.',
    waring1: 'Sie erteilen dem # die Berechtigung, Geräte zu verwalten.',
    ok: 'Ja',
    cancel: 'Abbrechen'
  },
  adddevice: {
    maintenance: 'Gerätefunktion in Wartung, bitte versuchen Sie es später erneut!',
    add: 'hinzufügen',
    back: 'Zurück',
    move: 'Verschieben',
    addto: 'Hinzufügen',
    realdevice: 'Gerät',
    realgateway: 'Smart Connect Box',
    virtualthirdparty: 'Vir-3rd party',
    virtualdevice: 'Vir-Gerät',
    virtualgateway: 'Vir-Smart Connect Box',
    realthirdparty: 'Dritte Partei',
    ethernet: 'Ethernet-Gerät',
    findQcode: 'Bitte finden Sie den QR-Code auf der Rückseite des Produkts',
    teleQcode: 'Scannen Sie den QR-Code mit dem Telefon, um die 80-Bit-Zeichenfolge zu erhalten.',
    example: 'Zum Beispiel',
    enoceanInfo: 'Der rote Teil ist die Mac-Adresse dieses Geräts und der grüne Teil ist der Repeater-Schlüssel.',
    copyInsert: 'Kopieren Sie die gesamte 80-stellige Zeichenfolge auf Ihren Computer und tragen Sie sie an der entsprechenden Stelle ein.',
    selectDeviceType: 'Gerätetyp auswählen',
    enterDeviceName: 'Geben Sie den zu suchenden Gerätenamen ein',
    MacAddress: 'Mac-Adresse & Schlüssel',
    findString: 'Wie findet man die Zeichenfolge?',
    qcString: 'Bitte geben Sie die Zeichenfolge des QR-Codes des Produkts ein',
    retry: 'Wählen Sie erneut',
    configure: 'Gehen Sie zu Konfigurieren',
    failDevice: '1 Gerät konnte nicht hinzugefügt werden, bitte überprüfen Sie, ob die Zeichenkette korrekt ist.',
    successDevice: 'Das Gerät wurde erfolgreich hinzugefügt. Um die normale Verwendung des Geräts zu gewährleisten, ist es notwendig, das Licht als Repeater-Knoten auszuwählen.',
    midConfig: 'Repeater-Konfiguration',
    secret: 'Taste',
    noDevice: 'Kein Gerät',
    requires32characters: 'Benötigt 32 Zeichen',
    moveTitle: 'Möchten Sie standardmäßig alle Geräte in diesen Raum verschieben? Wenn Sie sie jetzt nicht verschieben möchten, können Sie dies später im nicht zugewiesenen Bereich tun',
    movebnt1: 'Jetzt nicht verschieben',
    movebnt2: 'Verschieben',
    addMaxDeviceTitle: 'Unterstützung für das Hinzufügen von bis zu {{max}} Geräten',
    noDeviceTitle: 'Es gibt keine Lichter, die als Repeater-Knoten gesetzt werden können, oder die Firmware-Version ist zu niedrig. Sie müssen zuerst ein Upgrade durchführen und dann den Knoten als Repeater-Knoten setzen.',
    noAddTitle: 'Es gibt keine Connect Box, die diese Funktion unterstützt, oder die Firmware-Version ist zu niedrig, sie muss vor dem Pairing aktualisiert werden.',
    addSuccess: 'Erfolgreich hinzugefügt!',
    outRang: 'Außerhalb der Reichweite',
    least: 'Mindestens',
    upTo: 'höchstens',
    subDevice: 'Gateway-Subgerät',
    tianmu: 'Tianmu'
  },
  courseDataySync: {
    current: 'Status der Synchronisierung',
    history: 'Status der Synchronisierung',
    title: 'Synchronisierung',
    error: 'Status der Synchronisierung',
    tipInfo: 'Standardmäßig wird das Gerät in diesen Raum verschoben. Sind Sie sicher?',
    reset: 'Reset'
  },
  tree: {
    exportExcel: 'Bereichsbaum aus Excel-Datei importieren',
    downloadTemplate: 'Die Vorlage herunterladen',
    excelInfo: 'Wenn Sie den Flächenbaum nicht bearbeitet haben, laden Sie die Vorlage herunter und bearbeiten Sie sie entsprechend dem Format',
    excelTemplateName: 'Vorlage für Flächenbaum',
    uploadTemplate: 'Hochladen',
    uploadType: 'Unterstützt nur .xlsx und .xls Dateien',
    moveHere: 'Projekt übertragen',
    title: 'Knoten steuern',
    replaceExcel: 'Datei ersetzen',
    uploadTime: 'Upload-Zeit',
    plhode1: 'Suche',
    updatewaring: 'Bitte beenden Sie zuerst Ihre aktuelle Aufgabe',
    city: 'Bereich Baum',
    placeholdertree: 'Suche',
    submit: 'Ja',
    cancle: 'Nein',
    delmsg: 'Sind Sie sicher, dass Sie den Bereich löschen wollen？',
    addmsg: 'Name',
    treeMenuShowTip: 'Baumbereich Zusammenbruch',
    selfArea: 'Selbst',
    subArea: 'Unter',
    nopermission: 'Keine Berechtigung für den ausgewählten Bereich. Die Bereichsinformationen können nicht angezeigt werden. Bitte wenden Sie sich bei Bedarf an den Administrator, um die entsprechenden Berechtigungen hinzuzufügen.'
  },
  scene: {
    singleDeviceOne: 'Sie können nur bis zu einer einzelnen Geräte-Szene auswählen.',
    singleDevice: 'Single-Gerät-Szene',
    onlyQuerySingle: 'Nur Single-Device-Szenen abfragen',
    queryNonSingle: 'Abfragen von nicht-Geräte-Szenen',
    allScenarios: 'Alle Szenen',
    sceneNo: 'Szenennummer',
    masterControl: 'Gesamtsteuerung',
    partialControl: 'Partial Control',
    tianmuNoGo: 'Die Himmlische Sicherheit ist nicht bearbeitbar.',
    noFade: 'Ausblenden deaktiviert',
    question: 'Das DALI-Gerät unterstützt keine Szenen-Überblendzeit',
    deviceTypes: 'Bitte wählen Sie den Protokolltyp des Geräts',
    bluetooth: 'Bluetooth',
    converter: 'BLE-DALI-Konverter',
    sceneSelect: 'Szenauswahl',
    searchPlhode1: 'Szenenname/Schlüsselwort',
    lastScene: 'Zuletzt aktivierte szene Ausführungszeit',
    lastSceneTime: 'Betriebszeit',
    lastSceneNone: 'Keine Szene auszuführen',
    title: 'Schauplatz',
    plhode2: 'Name/Mac',
    plhode1: 'Name',
    add: 'Szene',
    adddevice: 'Gerät hinzufügen',
    caozuo: 'Aufgabe',
    remove: 'Verschieben',
    del: 'Löschen',
    dele: 'Löschen',
    power: 'Einstellen der maximalen Leistung',
    cancel: 'Abbrechen',
    all: 'Keine',
    allno: 'Alle',
    powerinfo: 'Die maximale Leistung ist',
    yes: 'Bestätigen Sie',
    state: 'Status：',
    block: 'Bereich：',
    go: 'Ausführen',
    deltext: 'Sind Sie sicher, dass Sie löschen wollen?',
    ok: 'Ja',
    control: 'Kontrolle Alle',
    controlsingle: 'Steuerung',
    device: 'Gerät',
    gateway: 'Smart Connect Box',
    deviceSelect: 'Wählen Sie das Gerät',
    selectScence: 'Es muss mindestens 1 Szene ausgewählt werden',
    blockSelect: 'Wählen Sie einen Bereich',
    roomwarn: 'Die Aktion kann nur auf der Raumebene durchgeführt werden',
    areawarn: 'Die Aktion kann nur auf der Ebene des Bereichs durchgeführt werden',
    powerOnInitState: 'Einschalten der Dimmstufe einstellen',
    lampGradual: 'Überblendzeit einstellen',
    lampLinkagePanel: 'Schalter zur Beleuchtungssteuerung einstellen',
    sensorExtTime: 'Einstellen der Sensorverzögerungszeit',
    powerOnInitStateInfo: 'Dimmstufe',
    lampGradualSwitchInfo: 'Geräteüberblendfunktion',
    lampGradualExtimeInfo: 'Die Geräteüberblendzeit beträgt',
    sensorExtTimeInfo: 'Die Sensorverzögerungszeit beträgt',
    blockSelectLimitTips: 'Tipp: Derzeit können Sie nur maximal 5# Bereiche auswählen!',
    blockOneSelect: 'Wählen Sie einen Bereich',
    blockMoreSelect: 'Wählen Sie mehrere Bereiche',
    gatewayDeleTip: 'Das gelöschte Gerät enthält ein Gateway. Nachdem das Gateway gelöscht wurde, wird auch das Gerät unter dem Gateway gelöscht.',
    batchResetInfo: "Setze den Rücksetzmodus auf",
    batchResetTypeNormal: 'Normalmodus',
    batchResetTypeExpert: 'Professioneller Modus',
    batchReset: 'Reset-Modus einstellen',
    batchConfigurePowerOnState: 'Einschaltzustand einstellen',
    PowerOnState: 'power-on status',
    PowerOnStatePrecious: 'precious status',
    PowerOnStateFixed: 'fixed status',
    open: 'open',
    close: 'close',
    selectSceneToCopy: 'Kopieren Sie die Szene',
    lightCount: 'Anzahl der Lampen',
    areaMapping: 'Bitte konfigurieren Sie zuerst die Region Mapping, bevor Sie die Szene ausführen',
    goConfig: 'Geh es konfigurieren',
    projectConfig: 'ProjektKonfiguration',
    batchConfig: 'Stapelkonfiguration',
    batchCLO: 'CLO-Parameter einstellen',
    DaliSulv: 'DALI-Dimmschaltgeschwindigkeit einstellen',
    batchCLOTips: 'CLO-Parameter',
    setBatchCLO: 'CLO-Parameter festlegen',
    NoFadeSupport: 'Die folgenden Geräte unterstützen die Funktion [Überblenddauer] nicht.Bitte stellen Sie die Überblenddauer auf den Standardwert ein.',
    FadeSupportAfterUpgrade: 'Die folgenden Geräte unterstützen die Funktion „Überblenddauer“ nach dem Upgrade.',
    WebImageScene: 'Web-Bildszene',
    defaultFadeByScene: 'Der Standardzustand übernimmt die Überblenddauer der Geräte aus der Szenenkonfiguration',
    fadeTime: 'Überblenddauer',
    sensorSensitive: 'Sensor-Empfindlichkeit einstellen',
    sensitivity: 'Empfindlichkeit',
    batchRename: 'Kanäle stapelweise umbenennen',
    LevelPerSecond: '{num} Stufen/Sekunde'
  },
  tianmu: {
    minutes: 'Minuten',
    onlyOneTime: 'Sie können nur 1 Gerät auswählen.',
    devicePlaying: 'Gerät wird abgespielt...',
    paused: 'Ausgestellt',
    times: 'Vielfaches',
    onlyFiveVedio: 'Nur 5 Videos werden unterstützt, um weiterhin hochzuladen, löschen Sie die anderen Videos.',
    noSolution: 'Kein Programm gefunden',
    noDownloadedVideo: 'Keine heruntergeladenen Videos vorhanden. Die Wiedergabe kann nicht fortgesetzt werden.',
    estimate: 'Schätzungen',
    clickToRetry: 'Klicken Sie erneut versuchen',
    static: 'Statisch',
    dynamic: 'dynamisch',
    noVideo: 'Keine Videoszene ausgewählt',
    customEditing: 'Benutzerdefinierte Bearbeitung',
    equipmentSchematic: 'Geräte-Diagramm',
    schemeAccepted: 'Programm akzeptiert',
    chooseNumber: '$$, eine.',
    multipleChoice: 'Mehr auswählen',
    master2: 'zwei',
    master3: 'drei',
    master4: 'vier',
    master5: 'fünf',
    notSupported: 'nicht unterstützt',
    maxSizeUniform: 'Maximale Größe: {max}m',
    maxSizeSides: 'Anforderungen: eine Seite ≤ {maxLong}m, die andere Seite ≤ {maxShort}m',
    minSizeUniform: 'Minimale Größe: {min}m',
    minSizeLampSides: 'Anforderungen: eine Seite ≥ {minLong}m, die andere Seite ≥ {minShort}m',
    circle: 'Kreis',
    radius: 'Radius',
    irregular: 'Sonderform',
    moduleMatch: 'Modulzuordnung',
    launchDate: 'Markteinführung',
    shapeSelection: 'Formauswahl',
    sdlModule: 'SDL-Modul',
    sdlModuleSingle: 'Einzelmodul (75*75mm)',
    sdlModuleCombo: 'Automatische optimale Verlegung (75*75mm, 100*600mm, 600*600mm)',
    lampModule: 'Leuchtenmodul',
    lineModule: 'Linienmodul',
    faceModuleTooltip: 'Integriertes Design für großflächige Montage an Wand, Decke, Boden usw.',
    lampModuleTooltip: 'Für vielfältige Raumbeleuchtung. Unterstützt Einzelmodul-Montage und freie Mehrfachkombination für Wand, Decke, Boden und weitere Bereiche',
    lineModuleTooltip: 'Praktisch und gestalterisch. Ideal für Büroflure, lineare Hoteldekoration, Retail-Randbeleuchtung und öffentliche Wegführung – für klare, gestreckte Linienlicht-Effekte',
    uploadDrawing: 'Zeichnung hochladen',
    windowShadow: 'Mit Fensterschatten',
    noWindowShadow: 'Ohne Fensterschatten',
    singleOffset: 'Einfach versetzt',
    doubleOffset: 'Doppelt versetzt',
    directDown: 'Direkt nach unten',
    lockedConfiguration: 'Festgelegte Konfiguration',
    ceilingCurtainDevice: 'Himmelsvorhang-Beleuchtung',
    Row: 'Zeile',
    Column: 'Spalte',
    layout: 'Anordnung',
    mainDevice: 'Master',
    slaveDevice: 'Slave',
    testDescribe: 'Testbeschreibung',
    InstallationDiagram: 'Installations- und Verdrahtungsdiagramm',
    power: 'Stromversorgung',
    square: 'Quadratisch',
    ceilingCurtain: 'Himmelsvorhang-Beleuchtungskonfiguration',
    lineDir: 'Verdrahtungsrichtung',
    lightSources: 'Abstand zwischen benachbarten Lichtquellen',
    lightSourceDistribution: 'Lichtquellenverteilung',
    lineMap: 'Gesamtverkabelungsplan',
    a3Info: 'Zum Drucken von Zeichnungen wird empfohlen, das Format A3 und Farbdruck zu verwenden.',
    constructionDepth: 'Bautiefe',
    solutionModuleInvalid: 'Aktuelle Länge und Breite überschreiten den Bereich dieses Moduls.',
    solutionModuleMinInvalid: 'Aktuelle Länge und Breite liegen unter dem Bereich dieses Moduls.',
    realPhotoProduct: 'Tatsächliche Produktspezifikationen',
    realPhoto: 'Echter Effekt',
    thicknessDeep: 'Dicke (Rinnentiefe)',
    specifications: 'Spezifikationen',
    exportsing: 'Exportieren: Bitte haben Sie etwas Geduld, der Vorgang kann einige Zeit dauern',
    installation: 'Installationsanforderungen',
    canvasInfo1: 'Die SDL-Lichtquellen sind gemäß den Zeichnungsvorgaben gleichmäßig anzuordnen, mit gleichmäßigem Abstand zwischen benachbarten Lichtquellen.',
    canvasInfo2: 'Die Deckenrinne muss aus Holztafeln gefertigt und weiß lackiert sein. Die Rinnentiefe beträgt $$ mm, und das Innere muss staubdicht behandelt werden, ohne überflüssige Löcher oder Spalten.',
    canvasInfo3: 'Die Wartungsklappe für den Treiber und Controller muss in der Nähe des Himmelsvorhangs angebracht sein, mit vorverlegten Stromkabeln.',
    canvasInfo4: 'Der Abstand zwischen Treiber und optischem Modul darf 5 Meter nicht überschreiten, und das Kabel muss mindestens 1,0 mm² Querschnitt haben.',
    canvasInfo5: 'Wenn ein einzelner Stromkreis mehr als 80 Pixel hat, wird eine zusätzliche Speisung an beiden Enden empfohlen.',
    designerTools: 'Designer-Werkzeuge',
    skyCeilingDesign: 'Himmelsdecken-Design',
    pointPreview: 'Punktvorschau',
    faceModule: 'Flächenmodul',
    workbenchZoomDrawing: 'Zeichnung zoomen',
    workbenchFilmLimit: 'Folienbegrenzung',
    workbenchFilmLimitValue: '4.2m',
    myDesigns: 'Meine Designs',
    createNewDesign: 'Neues Design erstellen',
    share: 'Teilen',
    viewDetails: 'Details anzeigen',
    designName: 'Designname',
    placeholderDesignName: 'Bitte geben Sie den Projektnamen ein',
    createShape: 'Form erstellen',
    specSettings: 'Spezifikationseinstellungen',
    width: 'Breite',
    thicknessSlotDepth: 'Dicke (Nuttiefe)',
    maintenanceHatchPosition: 'Wartungsöffnung Position',
    systemSettings: 'Systemeinstellungen',
    systemRecommend: 'Systemempfehlung',
    shortSide: 'Kurze Seite',
    longSide: 'Lange Seite',
    effectPreview: 'Effektvorschau',
    maintenanceHatch: 'Wartungsöffnung',
    lightDensity: 'Lichtquellendichte',
    selectControllerType: 'Controllertyp auswählen',
    singleChannelController: 'Einzelkanal-Controller',
    dualChannelController: 'Zweikanal-Controller',
    previewSceneLibrary: 'Szenenvorschau-Bibliothek',
    export: 'Exportieren',
    lightSourceInfo: 'Informationen zur Lichtquelle',
    billOfMaterials: 'Stückliste',
    lightDistributionDrawing: 'Lichtverteilungsplan',
    view: 'Ansehen',
    area: 'Fläche',
    lightingBlockchainCount: 'Anzahl der Leucht-Blocks',
    controllerCount: 'Anzahl der Controller',
    powerSupplyCount: 'Anzahl der Netzteile',
    maxPower: 'Maximale Leistung',
    productName: 'Produktname',
    partNumber: 'Teilenummer',
    description: 'Beschreibung',
    quantity: 'Menge',
    inputSpec: 'Eingabespezifikation',
    generateSolution: 'Lösung generieren',
    previousStep: 'Vorheriger Schritt',
    complete: 'Abschließen',
    nextStep: 'Nächster Schritt',
    exit: 'Beenden',
    bluetooth: 'Bluetooth',
    imagesOnly: 'Nur Bildszenen werden unterstützt',
    imagesAndVideosOnly: 'Unterstützt Bild- und Videoszenen',
    canopyMaxLengthNotice: 'Ein einzelnes Himmelsdeckenelement unterstützt eine maximale Länge von 15 m. Längen über 15 m werden aufgeteilt.',
    canopyMaxWidthNotice: 'Ein einzelnes Himmelsdeckenelement unterstützt eine maximale Breite von 4,2 m. Breiten über 4,2 m werden aufgeteilt.',
    maintenancePortInstruction: 'Das System wird automatisch die optimale Position empfohlen.',
    lightDensityDescription: 'Je höher die Lichtquellendichte, desto detaillierter die Szene – allerdings auch mit leicht höheren Kosten verbunden.',
    high: 'Hoch',
    middle: 'Mittel',
    low: 'Niedrig',
    delete: 'Löschen',
    size: 'Größe',
    nameLengthLimit: 'Der Name darf maximal 15 Zeichen lang sein.',
    nameRequired: 'Bitte geben Sie einen Namen ein.',
    shuangluPoint: 'Tatsächliche Punktzahl {{num}} stimmt nicht mit der aktuellen überein',
    oneKeyUpLevel: 'Ein-Klick-Upgrade',
    childDevice: 'Untergerät',
    lightLibrary: 'Lichteffektbibliothek',
    upImageTip: 'Tipp: Das Bild wird automatisch an die Gerätegröße angepasst.',
    customizeName: 'Benutzerdefinierter Name',
    configTip: 'Wird konfiguriert, bitte später erneut versuchen.',
    unbindTips: 'Nach dem Aufheben der Bindung der Lösung werden alle zugehörigen Untergeräte entfernt und alle damit verbundenen Szenen und Automatisierungen gelöscht. Möchten Sie wirklich fortfahren?',
    reBuildTips: 'Nachdem der Punkt neu gezeichnet wurde, und alle damit verbundenen Szenen und Automatisierungen gelöscht. Möchten Sie wirklich fortfahren?',
    delTips: 'Nach dem Löschen des Geräts werden alle zugehörigen Untergeräte entkoppelt und alle damit verbundenen Szenen und Automatisierungen gelöscht. Möchten Sie wirklich fortfahren?',
    delTips2: 'Zu den zu löschenden Geräten gehören auch Himmelsgeräte. Nach dem Löschen werden alle zugehörigen Untergeräte entkoppelt und alle damit verbundenen Szenen und Automatisierungen gelöscht.',
    channelCount: 'Kanalanzahl',
    pointCount: 'Punkte',
    addTianmuDevice: 'Tianmu-Gerät hinzufügen',
    guanlian: 'Zuordnen',
    bindPlan: 'Plan binden',
    bindDevice: 'Gerät binden',
    bindPlanTitle: 'Bitte wählen Sie einen Plan unter dem aktuellen Konto aus',
    bindDeviceTitle: 'Bitte wählen Sie das zu bindende Gerät aus',
    bindDeviceWarning: 'Bitte wählen Sie das zu bindende Gerät aus',
    shareWarning: 'Bitte geben Sie die Kontaktinformationen des Empfängers ein',
    shareWarning1: 'Bitte geben Sie ein gültiges Telefonnummerformat ein',
    shareWarning2: 'Bitte geben Sie ein gültiges E-Mail-Format ein',
    successMsg: 'Erfolgreich geteilt',
    shareTitle: 'Tianmu-Designplanfreigabe',
    notice: 'Benachrichtigung',
    sizeDesignNotAllowed: 'Größe kann nicht gestaltet werden',
    chooseOneOfTwo: 'Wähle eine von zwei Optionen',
    uploadVideo: 'Video hochladen',
    videoSize: 'MP4-Format, Größe unter 150M, Dauer nicht mehr als 1 Minute',
    onlyMp4Format: 'Dateiformat nicht unterstützt',
    onlyVideoSize: 'Dateigröße über 150M',
    onlyVideoTime: 'Dateien länger als 1 Minute',
    importVideo: 'Video importieren',
    upVideoTip: 'Das Video passt sich der Gerätegröße automatisch an und wird gestreckt.',
    overflowTip: 'Die Szene ist voll. Bitte löschen Sie einen Eintrag und versuchen Sie es erneut.',
    sure: 'Ja',
    configurationSchemeCannotDelete: '"Das Schema in der Konfiguration kann nicht gelöscht werden."',
    maxScenesLimit: 'Es können nur 5 Videoszenen übertragen werden.',
    productModel: 'Produktmodell',
    controllerType: 'Controller-Typ',
    createStandard: 'Erstellung eines Standardproduktplans',
    standard: 'Standardlösung',
    office: 'Bürogebäude',
    addDescription: 'Bitte fügen Sie eine Beschreibung hinzu.',
    aiCreate: 'AI erstellt Darstellung...',
    atUploading: 'Upload läuft...',
    historyList: 'Verlauf',
    uploadFailed: 'Laden fehlgeschlagen, bitte versuchen Sie es erneut.',
    qualityLight: 'Hochwertige Beleuchtung',
    UploadIorV: 'Bild / Video hochladen',
    aiCreateTip: 'Teilen Sie Ihre kreativen Ideen oder interessanten Bilder mit, um exklusive AI-Lichteffekte zu generieren!',
    sceneDescription: 'Geben Sie eine Beschreibung des Lichteffekts ein, z. B.: Morgensonnenlicht, Abendsonnenglanz.',
    myCreation: 'meine Kreation',
    enterNow: 'sofort eintreten',
    newConversation: 'KI wird generiert',
    aiCreating: 'KI wird generiert',
    aiFailed: 'KI-Generierung fehlgeschlagen',
    imageEditing: 'Bildbearbeitung',
    generatedImage: 'das generierte Bild',
    devicePreview: 'Gerätevorschau',
    saveToMyCreations: 'Speichern in meine Kreationen',
    picHasSaved: 'Das Bild wurde zu meinen Werken gespeichert.',
    creativeDescription: 'Bitte geben Sie Ihre kreative Beschreibung ein',
    sunsetGlow: 'Abenddämmerung',
    snowCcovered: 'schneebedeckt',
    groupSpacing: 'Gruppenabstand',
    addArray: 'Array hinzufügen',
    arrayInfo: 'Array-Informationen',
    arrayN: 'Array {n}',
    duplicateArrayLength: 'Länge {length} existiert bereits. Bitte wählen Sie eine andere Länge',
    lineLightLength: 'Länge der Linienleuchte',
    arrayCount: 'Array-Anzahl',
    densityModalDesc: 'Je höher die Lichtquellendichte, desto höher die Wandbeleuchtungsstärke und desto höher die Kosten',
    implementationSpec: 'Reale Produktspezifikationen',
    highDensity: 'Hohe Dichte',
    middleDensity: 'Mittlere Dichte',
    lowDensity: 'Niedrige Dichte',
    radiusLessThanMaxLen: 'Der Radius muss größer als die maximale Array-Länge {maxLen}m sein',
    radiusRequired: 'Radius darf nicht leer sein und wurde anhand der Array-Konfiguration zurückgesetzt',
    circleArrayEmpty: 'Bitte Array-Informationen hinzufügen und auf „Anwenden“ klicken, um die Punktvorschau anzuzeigen',
    arrayRequired: 'Array-Informationen der Linienleuchte dürfen nicht leer sein',
    arrayFieldRequired: 'Länge der Linienleuchte oder Array-Anzahl darf nicht leer sein',
    arrayApplyRequired: 'Bitte zuerst auf „Anwenden“ klicken, um die Punktvorschau zu erzeugen',
    arrayLayoutInvalid: 'Array-Layout-Validierung fehlgeschlagen. Bitte anpassen und erneut versuchen',
    wellSky: 'Well Sky',
    xidingDeng: 'Deckenleuchte',
    canDiao: 'Esszimmertischleuchte',
  },
  sceneTemplate: {
    warningTemplateTextAuto1: 'Bitte prüfen Sie, ob sich im aktuellen Bereich Leuchten befinden.',
    warningTemplateTextAuto2: 'Bitte prüfen Sie, ob sich im aktuellen Bereich Sensoren oder Schalter befinden.',
    warningTemplateTextAuto3: 'Wenn die Bedingungen 1 und 2 erfüllt sind, aber dennoch keine Daten vorliegen, bedeutet dies, dass derzeit keine Vorlagen verfügbar sind.',
    picScene: 'Bildszene',
    titleFreePic: 'Jetzt frei！',
    title: 'OPPLE Szenario-Vorlage',
    scheme: 'Lösung',
    preView: 'Vorschau',
    sure: 'Ja',
    finished: 'Erfolgreich',
    application: 'Anwenden',
    noMatchedDevice: 'Ungeeignete Geräte',
    selfDefine: 'Individuelle Szenen',
    templateDefine: 'Voreingestellte Szenen',
    warningText: 'Es gibt keine unterstützten Geräte in dem von Ihnen gewählten Bereich, bitte fügen Sie zuerst ein Gerät hinzu oder wählen Sie einen Bereich mit einem Gerät. Dann verwenden Sie die Szenenvorlage!',
    warningTemplateText: 'Es gibt keine Szenenvorlage in dem von Ihnen gewählten Bereich!',
    autoTitle: 'Automatisierungsvorlage',
    warningTextAuto: 'In diesem Bereich gibt es keinen Sensor. Bitte fügen Sie einen Sensor hinzu, um die Vorlagen verwenden zu können.',
    warningTemplateTextAuto: 'Es gibt derzeit keine Vorlagen in dem von Ihnen ausgewählten Bereich.',
    lightTripDefine: 'Lichtstreifendisplay-Szene',
    copyScene: 'Kopieren von Szenen',
    tianmu: 'Himmlische Sicherheit',
    sceneEffectPreview: 'Beispiel-Szene',
    selectImg: 'Wählen  Sie eine Vorlage oder ein benutzerdefiniertes Bild und laden Sie das Bild  hoch.',
    imageTemplate: 'Bildvorlage',
    customUpload: 'Laden Sie das benutzerdefinierte',
    morning: 'Erstes Morgenlicht',
    silentNight: 'Ruhiger Einbruch der Nacht',
    blueSky: 'Blauer Himmel und weiße Wolken',
    blueSkySun: 'Blauer Himmel, weiße Wolken und Sonne',
    holiday: 'Von der Sonne geküsste  Träumerei',
    sunsetGlow: 'Purpurrote Dämmerung',
    sunset: 'Dämmerungsglühen',
    risingSun: 'Aufsteigende Sonne',
    noNeedPath: 'In der aktuellen kreisförmigen Szene muss kein Pfad gezeichnet werden',
    needPath: 'In der aktuellen rechteckigen Szene bitte vor dem Speichern einen Pfad einzeichnen!',
    lightTripInputLampCount: 'Bitte geben Sie die Anzahl der Lichtschnitte pro Zeile ein, getrennt durch ",", zum Beispiel',
    createImageScenes: 'Erstellen einer Bildszene',
    chooseDevice: 'Wählen Sie die zu regelnden Geräte aus',
    tianmu2: 'Vordach',
    blueSkyLamp: 'SDL Oberlichter',
    selectStyle: 'Wählen Sie den Stil',
    selectLampType: 'Gerätetyp auswählen',
    select4: 'Bitte wählen Sie 4 Stück',
    lightingParameters: 'Licht-Parameter',
    lampMode: 'Lichtmodus',
    selectColor: 'Auswahl der Farbe',
    limit: 'Bild im jpg/png Format bis zu 3M Byte',
    screenSplicing: 'Screen Splicing',
    splicing: 'Splicing',
    noSplicing: 'Not Spliced',
    originalImage: 'Original',
    sdlColor: 'SDL Color',
    lightTripOption: 'Parameters Of The Light Strip',
    shadowEffect: 'Shadow Effect',
    clearSky: 'clearSky',
    dawn: 'dawn',
    twilightGlow: 'twilightGlow',
    blueSkyWhiteClouds: 'blueSkyWhiteClouds',
    rainbowAfterRain: 'rainbow',
    spring: 'spring',
    summerScenery: 'summer',
    cleanSweep: 'cleanSweep',
    winter: 'winter',
    blueSkyA: 'Blue SkyA',
    blueSkyB: 'Blue SkyB',
    synthesis: 'Mehrere Vorrichtungen zu einem Bild zusammenfügen',
    row: 'Anzahl der Zeilen',
    col: 'Anzahl der Spalten',
    Round4in1: 'Rund 4-in-1',
    customSize: 'Benutzerdefinierte Größe'
  },
  devicecard: {
    deviceAndChanel: 'Geräte&Kanäle',
    offline: 'Offline',
    online: 'Online',
    callpolice: 'Alarm',
    malfunction: 'Störung',
    lifeto: 'Lebensdauer über',
    attributes: 'Attribute',
    area: 'Bereich',
    switchstatus: 'Zustand des Schalters',
    light: 'Leuchtdichte',
    colortemperature: 'Farbtemperatur',
    illuminance: 'Beleuchtungsstärke',
    temperature: 'Temperatur',
    movement: 'Belegung',
    humidity: 'Luftfeuchtigkeit',
    co2: 'CO2',
    pm: 'PM2.5',
    power: 'Leistung',
    energyconsumption: 'Stromverbrauch',
    remaininglife: 'Verbleibende Lebensdauer',
    motortravel: 'Pegel',
    electricity: 'Energieverbrauch',
    motorangle: 'Grad',
    dataing: 'Datensynchronisierung',
    identification: 'Identifizieren Sie',
    plank: 'Aktuelles Dashboard',
    selected: 'Ausgewählte',
    info: 'Info',
    sameUnmoved: 'Sie können das Gerät nicht in denselben Bereich verschieben',
    delDeviceInfo: 'Bitte löschen Sie das Gerät auf der Installationsseite.',
    alreadycheck: 'Überprüft',
    nobind: 'Virtuell',
    dowarn: 'Info',
    refresh: 'Aktualisieren',
    ok: 'Ja',
    cancel: 'Abbrechen',
    nonametip: 'Name darf nicht leer sein',
    deviceTotal: 'Geräte',
    gatewayTotal: 'Geräte',
    identifNone: 'Dieses Gerät ist ein Gerät mit geringem Stromverbrauch, bitte sehen Sie in der Produktanleitung nach, um es zu identifizieren.',
    identif1: 'Drücken Sie, wie in der Abbildung gezeigt, gleichzeitig die "ON"-Taste auf der Vorderseite des Schalters und die "R"-Taste auf der Unterseite, dann leuchtet die LED-Anzeige auf und der Schalter geht in den Status "Warten auf das Upgrade" über.',
    identif2: 'Bitte drücken Sie einmal die Reset-Taste des Smart Sensors',
    identif3: '',
    noComma: 'Der Name enthält unzulässige Zeichen „#,#“. Bitte entfernen Sie diese, bevor Sie ihn einreichen'
  },
  sceneCard: {
    mode1: 'Modus1',
    mode2: 'Betriebsart1',
    mode3: 'Betriebsart1',
    mode4: 'Betriebsart1',
    mode5: 'Betriebsart1',
    mode0: 'Keine',
    state: 'Status：',
    block: 'Bereich：',
    go: 'Ausführen',
    base: 'Info',
    cao: 'Aufgabe',
    add: 'Hinzufügen',
    type: 'Typ',
    name: 'Name：',
    alreadydelete: 'Deviece wurde bereits gelöscht',
    alreadymove: 'Deviece wurde bereits verschoben',
    save: 'Speichern',
    back: 'Zurück',
    unifiedcontrol: 'Alles kontrollieren',
    up: 'Nach oben gehen',
    down: 'Nach unten gehen',
    lightSwitch: 'Aus/Ein',
    colorWarm: 'CCT',
    color: 'RGB',
    light: 'Dimmen',
    openLight: 'EIN',
    closeLight: 'AUS',
    selected: 'Ausgewählt',
    configuration: 'Einstellungen',
    allsuccess: 'Erfolgreich',
    onesuccess: 'Teilweise erfolgreich',
    allfail: 'Gescheitert',
    invalid: 'Ungültig',
    select: 'Wählen Sie',
    all: 'Alle',
    clear: 'Löschen',
    sceneId: 'ID：',
    joinYes: 'Aktivieren',
    joinNo: 'Deaktivieren',
    dim: 'Schritt dimmen',
    dimmingDown: 'Abwärts dimmen',
    dimmingUp: 'Aufwärts dimmen',
    cct: 'Schritt Farbtemperatur',
    cctWarm: 'Warm',
    cctCold: 'Kalt',
    selectDevice: 'Gerät auswählen',
    readReprot: 'Lesen',
    expandDeviceList: 'Geräteliste erweitern',
    allon: 'Alle',
    alloff: 'Alle',
    lightTripImg: 'Lichtstreifenszenen-Informationen',
    lightTripRankImg: 'Lichtstreifen-Anordnung',
    lightTripCanvasInfo2: 'Wählen Sie einen Lichtstreifen und zeichnen Sie ihn in den mittleren Bearbeitungsbereich.',
    lightTripCanvasInfo3: 'Wenn Sie mehrere Streifen zeichnen, versuchen Sie, die Streifen so gleichmäßig wie möglich auszurichten.',
    lightTripCanvasInfo4: 'Achten Sie darauf, dass alle Lichtstreifen innerhalb des Grafikbereichs gezeichnet werden.',
    lightTripCanvasDraw: 'Zeichnen von Pfaden',
    lightTripCanvasEdit: 'Pfad bearbeiten',
    lightTripCanvasDelete: 'Pfad löschen',
    lightTripCanvasBack: 'Pfad zurückziehen',
    lightTripRightAngle: 'Rechtwinkelmodus',
    lightTripCanvasDrawInfo: 'Wenn aktiviert, können Sie mit der linken Maustaste einen Ankerpunkt hinzufügen und mit der rechten Maustaste die Zeichnung beenden.',
    lightTripCanvasEditInfo: 'Wenn aktiviert, können Sie die Liniensegmente im Pfad mit der Maus ziehen.',
    lightTripCanvasDeleteInfo: 'Wenn aktiviert, können Sie den aktuell ausgewählten Pfad löschen.',
    lightTripCanvasBackInfo: 'Wenn aktiviert, kann der Pfad um einen Schritt zurückgezogen werden.',
    size: 'Größe',
    lightTripInputLampCount: 'Bitte geben Sie die Anzahl der LEDs ein.',
    lightCount: 'Anzahl der Lampen',
    line: 'Linie',
    circle: 'kreisförmig',
    senceWarning: 'Stellen  Sie den Gerätestatus auf der Seite ein, bevor Sie speichern!',
    noEdit: 'Die aktuelle Szene unterstützt die Editionsfunktion nicht.',
    noCopy: 'Die aktuelle Szene unterstützt die Kopierfunktion nicht.',
    workStatus: 'Status der arbeit',
    sceneNumber: 'Einsatzleitung',
    sensor: 'Eine mentale',
    alwaysOpen: 'normalerweise offen',
    alwaysClose: 'oft verbunden',
    sleep: 'Schlafzustand',
    leastOne: 'Bewahren Sie mindestens ein Gerät auf',
    noAvailableDevice: 'Keine verfügbaren Geräte',
  },
  install: {
    configTip: 'Tipps zur Konfiguration',
    measuringDeviceTip1: 'Nachdem das Gerät angeschlossen ist, führen Sie bitte die folgenden Schritte aus, um die Bereiche und Objekte des Messgeräts zu konfigurieren.',
    measuringDeviceTip2: 'Klicken Sie auf der Überwachungsseite auf „Parameterkonfiguration“.',
    measuringDeviceTip3: 'Konfigurieren Sie den Statistikbereich und das Objekt des Geräts unter „Energiestatistik-Konfiguration“.',
    deviceHasAtRoom: 'Das Gerät befindet sich bereits in diesem Raum',
    otaToolTip: 'RSSI',
    otaTipTitle1: 'Bitte aktualisieren Sie das/die untenstehende(n) Gerät(e) vor dem Umzug und der Benutzung auf die neueste Firmware!',
    otaTipTitle11: 'Nach erfolgreicher Aktualisierung:',
    otaTipTitle12: '1. Gehen Sie zum "nicht zugewiesenen Bereich" innerhalb der Registerkarte "Installation" auf der linken Seite.',
    otaTipTitle13: '2. Scrollen Sie im Bereichsbaum/Raumstruktur nach unten und klicken Sie auf "nicht zugeordneter Bereich".',
    otaTipTitle14: '3. Verschieben Sie die Geräte über die "Aufgabe" in der rechten oberen Ecke.',
    otaTipTitle15: '4. Wählen Sie die Geräte aus und klicken Sie auf "Verschieben".',
    otaTipTitle2: 'Gehen Sie zu Google play oder Apple store, um die OPPLE smart lighting App herunterzuladen.',
    otaTipTitle3: 'Es wird empfohlen, auf die neueste Firmware zu aktualisieren und dann umzuziehen.',
    otaTipTitleBatchAll: 'Die folgenden # Geräte müssen auf die neueste Firmware aktualisiert werden! Bitte gehen Sie zur Upgrade-Aufgabe, um den Fortschritt des Upgrades zu überprüfen.',
    otaTipTitleBatch: 'Nach erfolgreicher Aktualisierung:',
    otaTipTitleBatch1: '1. Gehen Sie zum "nicht zugewiesenen Bereich" innerhalb der Registerkarte "Installation" auf der linken Seite.',
    otaTipTitleBatch2: '2. Scrollen Sie im Bereichsbaum/Raumstruktur nach unten und klicken Sie auf "nicht zugeordneter Bereich".',
    otaTipTitleBatch3: '3. Verwenden Sie die Schaltfläche „Mit einem Klick verschieben“ in der oberen rechten Ecke, um alle im Raum markierten Geräte in den Zielraum zu verschieben.',
    otaTipTitleBatch4: '4. Oder verwenden Sie die Schaltfläche „Aufgabe – Verschieben“ in der oberen rechten Ecke, um alle ausgewählten Geräte in den Zielraum zu verschieben.',
    toWebTip: 'Zum Web-Upgrade gehen',
    toAppbTip: 'Zum App-Upgrade gehen',
    continue: 'Weiter',
    getInfo: 'AKTUALISIERT',
    deviceType: 'Gerätetyp',
    protocol: 'Verbindungstyp',
    typeAname: 'Name/Mac',
    choose: 'Wählen Sie',
    remveblock: 'Verschieben',
    finsh: 'Fertigstellen',
    devicecounterror: 'Ein Gerät auswählen',
    areacounterror: 'Einen Bereich auswählen',
    loading: 'Laden',
    noarea: 'Nicht zugewiesene(s) Gerät(e)',
    truegateway: 'Smart Connect Box',
    truedevice: 'Gerät',
    powerwarn: 'Bitte geben Sie eine gültige Nummer ein (>0)',
    slelectModifyNameCaption: 'Schnellauswahl',
    deviceFilter: 'Geräte-Filter',
    deviceStatus: 'Status',
    duplicateAreatips: 'Bitte löschen Sie die Szene und die Automation des Zielbereichs, bevor Sie den Kopiervorgang durchführen',
    duplicateNativeTipInfo: 'Einführung',
    duplicateNativeTipSelectAre: 'Quellbereich',
    duplicateNativeTipBind: 'Kopieren',
    duplicateNativeTipMain: 'Fertigstellen',
    duplicateNativeInfo: 'Bitte stellen Sie sicher, dass die Voraussetzungen erfüllt sind, bevor Sie diesen Schritt starten:',
    duplicateNativeInfo1: 'Der Zielbereich sollte Geräte enthalten, die den gleichen Gerätetyp und die gleichen Gerätenamen haben wie im Quellbereich.',
    duplicateNativeInfo2: 'Die Szenen und Automationen im Quellbereich dürfen keine Geräte enthalten, die verschoben oder gelöscht wurden.',
    duplicateNativeInfo3: 'Bitte löschen Sie die Szenen und Automationen des Zielbereichs, bevor Sie den Kopiervorgang durchführen.',
    duplicateNativeInfoConfirm: 'Die oben genannten Bedingungen wurden bestätigt',
    duplicateStart: 'Duplizieren',
    duplicateTargetArea: 'Zielbereich',
    duplicateSourceArea: 'Quellbereich',
    duplicateArea: 'Doppeltes',
    duplicateBindErrorTip: 'Die Geräte im Zielbereich haben nicht die gleiche Nummer/Name/Typ wie die Geräte im Quellbereich. Sie können nicht zum nächsten Schritt übergehen.',
    duplicateBindRelaErrorTip: 'Die Gerätezuordnungsbeziehung ist falsch',
    duplicateInfo1: 'Es ist möglich, dass sich im Zielbereich mehr Geräte befinden, aber nicht weniger als im Quellbereich.',
    duplicateInfo2: 'Die Geräte im Zielbereich haben nicht denselben Namen/Typ wie die Geräte im Quellbereich. Es ist nicht möglich, zum nächsten Schritt überzugehen.',
    duplicateInfo3: 'Die Anzahl der Geräte im Zielbereich ist kleiner als die Anzahl der Geräte im Quellbereich. Es ist nicht möglich, mit dem nächsten Schritt fortzufahren.',
    duplicateInfo4: 'Die Geräte in den Szenen/Automationen stimmen mit den aktuellen Raumeinstellungen überein. Sie können mit dem nächsten Schritt fortfahren.',
    duplicateInfo5: 'Die Geräte in den Szenen/Automationen wurden verschoben/gelöscht. Sie können nicht mit dem nächsten Schritt fortfahren. Bitte korrigieren Sie zuerst die Szenen/Automationen im Quellbereich.',
    sceneNumberConfig: 'Szenario-Konfiguration',
    sceneNumberCount: 'Szenario-ID-Anzahl:',
    inputTip: 'Bitte geben Sie Inhalte ein',
    areaMapping: 'Flächenkartierung',
    sceneConfig: 'Szenario-Konfiguration',
    duplicateAreaNumber: 'Es gibt doppelte Vorwahlen, bitte überprüfen Sie diese vor dem Speichern',
    doNotShowThisAgain: 'Nicht mehr anzeigen',
    deviceAdded: 'Insgesamt wurden # Geräte erfolgreich hinzugefügt.',
    addResult: 'In dieser Sitzung wurden ${totalNUm} Geräte hinzugefügt. ${successMoveNUm} Geräte wurden erfolgreich in den Zielraum verschoben. Die verbleibenden ${needOTaNUm} Geräte müssen vor dem Verschieben mit einer Firmware-Aktualisierung versehen werden. Bitte klicken Sie auf „Fertigstellen“, um mit dem Update im Bereich „Nicht zugewiesener Bereich“ fortzufahren. Sobald das Update abgeschlossen ist, können diese Geräte verschoben werden. Wenn Sie weitere Geräte hinzufügen möchten, klicken Sie bitte auf „Weiter“.',
    forceUpgrade: 'Forced upgrade',
    batchUpgrade: 'Ein-Klick-Upgrade',
    batchMove: 'Ein-Klick-Verschieben',
    moveOnlyMarked: 'Nur Geräte, die mit dem Zielraum markiert und auf die neueste Firmware-Version aktualisiert wurden, können mit der Funktion „Ein-Klick-Verschieben” verschoben werden.',
    noUpgradableDevices: 'Derzeit sind keine Geräte für ein Upgrade verfügbar.',
    movableDevices: 'Es sind keine Geräte für eine Verschiebung verfügbar.',
    overwriteTargetWarning: 'Der für das Gerät markierte Zielraum wird überschrieben. Möchten Sie fortfahren?',
    targetArea: 'Zielraum',
    aiTokenFailed: 'Fehler beim Abrufen des AI-Tokens',
  },
  deviceVirtual: {
    span: 'Gerät hinzufügen',
    header: 'Gateway auswählen',
    nextstep: 'Schritt',
    wifitype: 'Wählen Sie',
    nolinewifi: 'Wifi-Gateway',
    devicetype: 'Typ',
    placeholderone: 'Wählen Sie',
    placeholdertwo: 'Name eingeben',
    yes: 'Ja',
    addwifi: 'Gateway hinzufügen',
    devicetypewarning: 'Typ auswählen',
    wifitypewarning: 'Gateway auswählen',
    gatewayerror: 'Bitte fügen Sie zuerst eine Smart Connect Box hinzu',
    xylx: 'Typ auswählen'
  },
  deviceMsg: {
    wait: 'Warten...',
    resetRelayDevice: 'Relaisgerät zurücksetzen.',
    lightMode1: 'Strahlendes Tageslicht',
    lightMode2: 'Kaleidoskopisches Leuchten',
    lightMode3: 'Weißes Licht',
    lightMode4: 'Reine Farbe',
    lightMode5: 'music',
    area: 'Bereich',
    basicinformation: 'Geräte-Infos',
    devicename: 'Name',
    devicetype: 'Typ',
    devicestatus: 'Status',
    online: 'Online',
    offline: 'Offline',
    agreementtype: 'Verbindungstyp',
    mac: 'MAC-Adresse',
    deviceclassification: 'SKU',
    deviceclassificationname: 'Gerätetyp',
    cloudid: 'Cloud-ID',
    virtualid: 'Vir-Cloud-ID',
    createdtime: 'Erstellungszeit',
    loopid: 'Kanal-ID',
    loopname: 'Kanal',
    devicetypeid: 'SKU',
    more: 'Mehr',
    collapse: 'Weniger',
    deviceoperating: 'Aufgabe',
    move: 'Verschieben',
    replace: 'Ersetzen',
    delete: 'Löschen',
    factorysetting: 'Zurücksetzen',
    restart: 'Neu starten',
    stop: 'Anhalten',
    start: 'Starten',
    parameter: 'Geräteparameter',
    ota: 'Firmware',
    currentversion: 'Aktuelle Version',
    newversion: 'Cloud-Version',
    uptodate: 'NEU',
    advancedoptions: 'Erweiterte Optionen',
    specificversion: 'Spezielle Version',
    upgrade: 'Aktualisierung',
    pause: 'Pause',
    issued: 'Herunterladen der Datei',
    initiatefail: 'Upgrade fehlgeschlagen',
    ingfail: 'Upgrade fehlgeschlagen',
    stopfail: 'Stop fehlgeschlagen',
    stopsuccess: 'Stop erfolgreich',
    prompt: 'Info',
    deletedeviceinfor: 'Sind Sie sicher, dass Sie löschen wollen?',
    resetdeviceinfor: 'Sind Sie sicher, dass Sie zurücksetzen können?',
    restartdeviceinfor: 'Sind Sie sicher, dass Sie neu starten sollten?',
    replacedeviceinfor: 'Sind Sie sicher, dass Sie ersetzen können?',
    calibratedeviceinfor: 'Sind Sie sicher, dass Sie kalibrieren wollen?',
    save: 'Sicher',
    cancle: 'Abbrechen',
    configsuccess: 'Erfolg',
    configing: 'Konfigurieren von',
    configfail: 'Fehlgeschlagen',
    configdefault: 'Standard',
    hightOption: 'Erweiterte Optionen',
    specificVersion: 'Besondere Version',
    uppage: 'Nach oben gehen',
    downpage: 'Nach unten gehen',
    savesubmit: 'Speichern',
    uplevel: 'Aktualisieren',
    waitForupgrade: 'Warten auf Upgrade',
    Upgradeing: 'Aktualisieren von',
    UpgradeSuccess: 'Erfolgreich',
    UpgradeDuplicate: 'Dupliziert',
    UpgradeFail: 'Gescheitert',
    UpgradeConfilct: 'Ein Konflikt ist aufgetreten!',
    UpgradeBusy: 'Besetzt',
    UpgradeProjectIdNull: 'Bitte geben Sie die Projekt-ID ein',
    parentdevicename: 'Übergeordnetes Gerät',
    calibrate: 'Kalibrieren',
    calibrateLUX: 'Kalibriert Lux',
    calibrateLUXButton: 'Einstellen',
    calibrateLUXTip: 'Kalibrieren',
    calibrateTemp: 'Kalibrieren Temp',
    calibrateTempButton: 'Einstellen',
    calibrateTempTip: 'Kalibrieren',
    sure: 'Sicher',
    calibrateBoxTip: 'Der aktuelle Wert der Desktop-Beleuchtung',
    calibrateHistoryTip: 'Aufgezeichneter Lux-Wert',
    calibrateAddItem: 'Hinzufügen',
    calibrateItemRealityTip: 'Aktueller Sensorwert',
    calibrateItemInputTip: 'Aktueller Wert des Luxmeter',
    calibrateItemWriteTip: 'Bitte geben Sie den Wert des Luxmeters ein',
    calibrateItemLimitTip: 'Bitte fügen Sie nicht mehr als # Datensätze hinzu. ',
    otaupdateBleTip: 'Die Geräte desselben Typs werden alle auf einmal aktualisiert. Dies kann mehr als 30 Minuten pro Typ dauern.',
    isActionPostTitle: 'Live-Szenenvorschau',
    calibrateTempBoxTip: 'Der aktuelle Wert der Desktop-Temperatur',
    calibrateTempHistoryTip: 'Aufgezeichneter Temperaturwert',
    calibrateTempItemRealityTip: 'Aktueller Temperatur-Istwert',
    calibrateTempItemInputTip: 'Aktuell gemessene Temperatur',
    calibrateTempItemWriteTip: 'Eingabe des gemessenen Temperaturwerts',
    gateWayBoard: 'Board',
    gateWaySubCard: 'Karte',
    morefirmwaretip: 'Die folgende Firmware gehört zum Gerät und kann nur schrittweise aufgerüstet werden.',
    morefirmwareview: 'Aktuellen Stand der Firmware anzeigen',
    canUpgradeingMaster: 'Aktualisierbar',
    firmwareNo: 'Seriell',
    otabootTrue: 'Die oben genannten Vorgänge wurden bestätigt',
    lengthLimit: 'Bitte geben Sie 1-{{length}} Zeichen ein',
    heating: 'Heizung',
    refrigeration: 'Kühlen',
    dehumidification: 'Entfeuchten',
    airSupply: 'Zuluft',
    soundOff: 'Leise',
    LSpeed: 'Niedrige Drehzahl',
    MSpeed: 'Mittlere Drehzahl',
    HSpeed: 'Hohe Drehzahl',
    auto: 'Automatisch',
    groupPlaceholder: 'Geben  Sie die Nummer der Nachbargruppe von 0-250 ein.',
    group: 'Gruppe',
    area2: 'unterscheiden',
    groupTips: 'Fügen Sie bis zu 8 Nachbargruppen hinzu',
    colorCustomize: 'Angepasst',
    cxCyEmpty: 'Bitte geben Sie die Farbkoordinaten Cx und Cy im Format 0.0000, 0.0000 ein',
    cxCyFormatError: 'Bitte geben Sie ein gültiges Koordinatenformat ein, z. B. 0.4527, 0.3937',
    cxCyOutOfRange: 'Die Farbkoordinaten liegen außerhalb des gültigen Bereichs. Bitte erneut eingeben',
    validHexColor: 'Bitte geben Sie einen gültigen Hexadezimalfarbwert ein',
    rangeOfTheColorPalette: 'Eingabe von Farbwerten außerhalb des Palettenbereichs, in Palettenfarbe korrigiert',
    know: 'Verstanden！',
    ciexy: 'CIExy',
    noRelationDevice: 'Im Moment keine zugeordneten Geräte',
    refreshing: 'Wird aktualisiert...',
    refreshFail: 'Aktualisierung fehlgeschlagen. Bitte versuchen Sie es erneut',
    refreshSuccess: 'Aktualisierung erfolgreich',
    pleaseSetWifi: 'Bitte stellen Sie Wi-Fi erst in der Parameterkonfiguration ein!',
    lengthLimit1: 'Bitte die Textlänge begrenzen',
    lengthLimit2: 'Bitte die Passwortlänge begrenzen',
    screenSetting: 'Bildschirm Einstellung',
    defaultScreen: 'Standardbildschirm',
    maxScreenSettingTips: 'Unterstützt bis zu {{MaxCount}} ',
    keySetting: 'Schaltfläche einrichtung',
    keyInput: 'Bitte geben Sie die Schaltflächenbeschriftung ein',
    unSetting: 'Nicht eingestellt',
    secondDeleteConfirm: 'Die Szenarien und die Automatisierung im Zusammenhang mit #name# und seinen Untergeräten werden ungültig. Sind Sie sicher, sie zu löschen?',
    option1: 'Option 1',
    option2: 'Option 2',
    changeBind: 'Bindung ändern',
    sureOk: 'Bestätigung des Abschlusses des oben genannten Prozesses.',
    replaceMain: 'Master-Einheit ersetzen',
    replaceSlave: 'Slave-Einheit ersetzen',
    goodness: 'Anpassungsgüte',
    excellent: 'Ausgezeichnet',
    makeDo: 'Durchschnittlich',
    poor: 'Schlecht',
    tropic: 'Beste Anpassungsgerade',
    rawData: 'Rohdaten',
    noOtaDevice: 'In diesem Gebiet sind keine Geräte für ein Upgrade verfügbar',
    recommendedValue: 'Empfohlener Wert',
    pleaseSelectDataType: 'Bitte Datentyp auswählen:',
    lightAndPpfd: 'Licht und photosynthetische Photonenflussdichte (PPFD)',
    channelCountChanged: 'Kanalanzahl geändert; bitte Controller Nr. {errorIndex} prüfen'
  },
  colorPicker: {
    gradient: 'Auswahl des Farbverlaufs',
    gradientNum: 'Wählen Sie mindestens {{min}} Farben aus.',
    gradientNum2: 'Nicht mehr als {{max}}'
  },
  deviceChoose: {
    choose: 'Gerät(e) auswählen',
    group: 'Gruppe speichern',
    save: 'speichern',
    groupwarning: 'Einen Gruppennamen eingeben',
    sure: 'Bestätigen Sie',
    groupsingle: 'Gruppe',
    checkwarning: 'Bitte wählen Sie mindestens ein Gerät aus',
    checkgroupwarning: 'Bitte kreuzen Sie zuerst das Kästchen an',
    devicestotal: 'Gerät(e)',
    overStepDeviceGroupTip: 'Die gerenderten Geräte befinden sich nicht in demselben Bereich, und diese Gruppe wird in dem angegebenen Bereich gespeichert',
    chooseDeviceInMap: 'Auswahl des Grundrisses verwenden'
  },
  addScenes: {
    work: 'Arbeit',
    offwork: 'Feierabend',
    rest: 'Ruhen',
    sweep: 'Kehren',
    emergency: 'Notfall',
    none: 'Keine',
    scenenamewarning: 'Bitte geben Sie der Szene einen Namen',
    actionwarning: 'Bitte wählen Sie das Gerät',
    select: 'Wählen Sie',
    isLightActionAutoOpareTip: 'Wenn Sie möchten, dass die Leuchte eingeschaltet wird, wenn diese Szene aktiviert wird, stellen Sie sicher, dass die Schaltfunktion aktiviert ist und der Schalter auf Ein steht.'
  },
  ifttt: {
    searchPlhode1: 'Name/Schlüsselwort der Automatisierung',
    iftttSetTemplate: 'Wichtig! Bei gleichzeitiger Verwendung einer Sensorautomatik und der Tageslichtsteuerung können Sie nur die Vorlage EIN*-AUS (keine Helligkeitsteuerung) verwenden!',
    constillumsetTips: 'Geräte, die an der automatisierten Helligkeitsanpassung teilgenommen haben, können nicht gleichzeitig an der Automatisierung für konstante Beleuchtungsstärke teilnehmen.',
    constillumset: 'Tageslichtsteuerung',
    aleadyset: 'Konfiguriert',
    rhythmset: 'Zeitsteuerung',
    customize: 'Benutzerdefinierte Automatisierung',
    template: 'Büro-Vorlage',
    clouddo: 'Cloud',
    proximaldo: 'Smart Connect Box',
    success: 'Erfolg',
    fail: 'Fehlschlag',
    ing: 'Einstellung',
    custommode: 'Benutzerdefiniert',
    illuminationmodel: 'Tageslicht',
    rhythmode: 'Zeitplan ',
    manual: 'Manuell',
    status: 'Status',
    time: 'Zeit',
    delcounterror: 'Wählen Sie eine',
    light: 'Tageslichtsteuerung',
    allset: 'Konfiguriert',
    rhythm: 'Zeitplan ',
    templateName: 'Vorlage',
    template2: 'Andere Vorlage',
    handle: 'Manuell',
    templateName2: 'Vorlage',
    rhythm00: 'Wählen Sie Smart Connect Box',
    rhythm01: 'Gerät(e) auswählen',
    lightTripOption: 'Einstellen der Parameter der Lichtleiste',
    lightTripSelect: 'Wählen Sie die einzustellende Lichtleiste aus',
    lightTripLampCount: 'Bitte geben Sie die Anzahl der LEDs der einzelnen Lichtleiste ein',
    lightTripDirection: 'Bitte wählen Sie die Ausrichtungsart des Lichtbandes',
    lightTripTransverse: 'Horizontal',
    lightTripVertical: 'Vertikal',
    rhythm02: 'Zeitplan festlegen',
    rhythmLine: 'Zeitplan Kurve',
    set: 'einstellen',
    lightDevice: 'Leuchten',
    window: 'Vorhang',
    lightName: 'Stufe',
    colorName: 'Farbtemperatur',
    addTime: 'hinzufügen',
    openDegree: 'OpenDegree',
    Degree: 'Grad',
    info: 'OpenDegree：das Verhältnis des Flügels zur Gesamtfläche des Rollladens; Degree：der Winkel, in dem sich die Flügel von Rollläden öffnen。',
    save: 'Speichern',
    upStep: 'Zurück',
    yes: 'Bestätigen',
    sun: 'Ebene',
    light00: 'Smart Connect Box auswählen',
    light01: 'Wählen Sie den Tageslichtsensor',
    light02: 'Wählen Sie die tageslichtgesteuerten Leuchten',
    light03: 'Anforderungen',
    light04: 'Kalibrierung',
    requirement: 'Anforderungen',
    requirement01: 'Kalibrieren Sie den Beleuchtungsstärkewert des Sensors;',
    requirement02: 'Sicherstellen, dass der Einfluss des Sonnenlichts auf den Sensor während der Installation 70 % nicht übersteigt;',
    requirement03: 'Stellen Sie sicher, dass die Ablesung des Sensors und des Luxmeters zum Zeitpunkt der Installation nicht gestört wird;',
    requirement04: 'Bitte geben Sie den Wert der Beleuchtungsstärke nach der Kalibrierung des Referenzpunktes ein.',
    farmingRequirement01: 'Halten Sie die lichtempfindliche Fläche horizontal nach oben gerichtet, fern von Säulen, Sprinklern, Leuchten und anderen Bereichen mit Verdeckung oder Spritzwasser;',
    farmingRequirement02: 'Befestigen Sie mit einer starren Halterung; trennen Sie Signalleitungen von Stromleitungen und verschließen Sie Anschlüsse wasserdicht;',
    farmingRequirement03: 'Platzieren Sie Messpunkte in der Mitte des Anbaugebiets; bei großen Flächen mehrere Punkte zonenweise anordnen;',
    farmingRequirement04: 'Reinigen Sie die Lichtkuppel regelmäßig, um Verunreinigungen zu vermeiden, die die Messgenauigkeit beeinträchtigen.',
    nextStep: 'Weiter',
    luxNum: 'Sensor：',
    watch01: 'Überprüfen Sie Ihr Luxmeter',
    watch02: 'Stellen Sie die Dimmstufe der Leuchte ein',
    address: 'Bereich',
    standard: 'Beleuchtungsstärke Standardwert (Lux).',
    timeSet: 'Stellen Sie die Eigenschaften des Geräts in verschiedenen Zeiträumen ein',
    timeAdd: 'Zu',
    timeStart: 'Beginn',
    timeEnd: 'Ende',
    timePlaceholder: 'Zeitintervall',
    templateState: 'Status',
    execute: 'Cloud',
    baseMsg: 'Infos',
    tempateName: 'Name：',
    iftttSet: 'Automatisierung',
    rangTime: 'Effektive Zeit',
    day: 'Arbeitstage/alle Zeit',
    add: 'hinzufügen',
    if: 'Wenn',
    iftttPlaceholder: 'Wählen Sie',
    timing: 'Zeitmessung',
    stating: 'Tun',
    delayed: 'Verzögern',
    minute: 'Min',
    statingGo: 'Do',
    back: 'Zurück',
    week: 'Woche',
    weekpush: 'Feiertage ausgeschlossen',
    cancel: 'Abbrechen',
    timingset: 'Zeit',
    templateManger: 'Vorlagenverwaltung',
    templatetext: 'Vorlage',
    templateinfo: 'hinzufügen',
    addTemplate: 'Hinzufügen',
    closeRhythm: 'Zeitplan deaktivieren ',
    addPanel: 'Schalter hinzufügen',
    PanelInfo: 'Drücken Sie die Taste des Schalters',
    dayPlaceholder: 'Daten auswählen',
    'trigger ': 'Auslösen',
    introduce: 'einführen',
    scence: 'Einführen',
    closeLight: 'Alle Leuchten ausschalten',
    trigger: 'Auslösen',
    open: 'EIN',
    close: 'AUS',
    addressText1: 'Wohnzimmer (allgemeine Aktivitäten)',
    addressText2: 'Wohnzimmer (Schreiben und Lesen)',
    addressText3: 'Speisesaal',
    addressText4: 'Lesesaal ',
    addressText5: 'Allgemeines Büro',
    addressText6: 'Supermarkt-Halle',
    addressText7: 'Wartezimmer im Krankenhaus',
    addressText8: 'Klassenzimmer in der Schule',
    addressText9: 'Schwarze Tafel in der Schule ',
    addressText10: 'Korridor',
    addressText11: 'Bearbeitung',
    Illuminance: 'Lux',
    color: 'Farbe',
    zdy: 'Bitte gehen Sie zu den Einstellungen ',
    zdylight: 'Bitte gehen Sie zu den Einstellungen ',
    hourxh: 'Standardmodus (24h)',
    secondsxh: 'Modus anzeigen (24s)',
    warning1: 'Ein Gerät auswählen',
    warning2: 'Bitte wählen Sie eine Ausführungszeit',
    warning3: 'Zeitkonflikte, bitte wählen Sie eine Ausführungszeit',
    warning4: 'Wählen Sie eine Zeitspanne, um Konflikte zu vermeiden',
    no: 'NO',
    iftttSelect: 'Automatisierung auswählen (ifttt)',
    selectIFTTT: 'Bitte wählen Sie mindestens eine Automatisierung (ifttt)',
    openSwitch: 'EIN',
    closeSwitch: 'AUS',
    del: 'Löschen',
    selected: 'Ausgewählt',
    farGoing: 'Verarbeitet über Cloud',
    nearGoing: 'Verarbeitet über die Smart Connect Box',
    timingDot: 'Zeitschaltuhr：',
    sensorDot: 'Sensor：',
    rhythmtime: 'Zeit',
    nowarn: 'Leider können Sie den Schleifenstatus in diesem Schritt nicht ändern.',
    groupControl: 'Gruppe',
    timeStarToEnd: 'Ausgewählter Zeitraum (Endzeit ist größer oder gleich der Startzeit)',
    selectGateway: 'Bitte wählen Sie die Smart Connect Box aus',
    groupControlTip: 'Nachdem die Gruppensteuerung ausgewählt wurde, sind alle aktuellen Geräte und Gruppen nicht mehr verfügbar!',
    noFindGateWayTip: 'Keine Smart Connect Box verfügbar',
    luxCorrectNum: 'Kalibrierter Lux-Wert：',
    constillumName: 'Name der Tageslichtautomatik',
    rhythmName: 'Name des Zeitplans ',
    constillumNameTips: 'Bitte geben Sie hier einen Namen für die Tageslichtautomation an',
    rhythmNameTips: 'Bitte geben Sie einen Zeitplannamen ein',
    rhythmSelectJoinModel: 'Freigeben',
    manualmode: 'Manuell',
    panelmode: 'Intelligenter Schalter',
    devicemode: 'Intelligenter Sensor',
    schedulemode: 'Zeitsteuerung',
    nonemode: 'Keine',
    sensorCorrectionTips: 'Hinweis: Der Sensor wurde noch nicht kalibriert. Bitte kalibrieren Sie den Sensor zuerst auf der Installationsseite. ',
    automationTotal: 'Automatisierung Total',
    iftttCustomSetPanel: 'Intelligenter Schalter',
    iftttSelectPanel: 'Smart Switch auswählen',
    iftttDefaultNoRealImg: 'Bild noch nicht verfügbar',
    automationRules: 'Automatisierungsregeln',
    configurationDetails: 'Details zur Konfiguration',
    maxConfigMessage: 'Maximal 10 Zeitpunkte ',
    maxConfigMessage30: 'Maximal 30 Zeitpunkte ',
    configWarnMessage: 'Der Abstand zwischen zwei Punkten sollte mehr als 1 Stunde betragen.',
    hclConfig: 'HCL',
    lightTripConfig: 'Konfiguration des Streifens',
    templateConfig: 'Voreingestellte Automatisierung',
    hcl: 'HCL',
    areacontrol: 'Bereichskontrolle',
    hclNameTips: 'Bitte geben Sie einen Namen für das HCL-Programm ein',
    hclName: 'HCL-Programmname',
    hcl02: 'HCL-Kurve einstellen',
    hclLine: 'Ansicht der HCL-Kurve',
    copyIfttt: 'IFTTT kopieren',
    isLoadingData: 'Laden von Daten Bitte warten Sie einen Moment',
    notice: 'Benachrichtigung',
    needOneClickConfiguration: 'Ob eine Ein-Klick-Konfiguration erforderlich ist',
    oneClickConfiguration: 'Ein-Klick-Konfiguration',
    elfInfo: 'Die Ein-Klick-Konfiguration konfiguriert automatisch die Automatisierung für die Schaltflächen "Ein/Aus", "Helligkeit", "Farbtemperatur/Farbe". Szenen müssen auf der Geräte-Detailseite konfiguriert werden.',
    controlObject: 'Geräte steuern',
    wakePro: 'Bitte wecken Sie das Gerät auf, indem Sie auf eine beliebige Taste des Geräts klicken, und klicken Sie auf "Speichern".',
    wakeProRetry: 'Bitte wecken Sie das Gerät auf, indem Sie auf eine beliebige Taste des Geräts klicken.',
    aWakened: 'Aufwecken',
    associatedConfiguration: 'Bündel-Konfigurationen',
    associatedInfo: 'Bitte fügen Sie die Geräte hinzu',
    associatedConditioning: 'Klimagerät bündeln',
    addObject: 'Geräte hinzufügen',
    noConfiguration: 'Keine Konfiguration',
    buttonAutomation: 'Automatisierungskonfiguration der Tasten',
    createUp3: 'Bis zu ${{n}} Geräte erstellen',
    selectObjects: 'Geräte auswählen',
    intelligentControl: 'Sichern (optional)',
    clickExecute: 'Kurzes Drücken zur Ausführung',
    lightDetection: 'Licht-Erkennung',
    clickDetect: 'Anklicken zum Erkennen',
    switchFn1: 'Anklicken, um die Funktion zu wechseln',
    switchFn2: 'Drehen, um den Wert einzustellen',
    onOff: 'Kurzes Drücken zum Ein- und Ausschalten des Lichts',
    rotate: 'Drehen',
    constantIlluminanceTip: 'Wenn die konstante Beleuchtungsstrategie die Helligkeit der Lampe auf die niedrigste Stufe einstellt, schalten Sie das Licht aus',
    chooseSame: 'Bitte wählen Sie ähnliche Geräte',
    sureUseIfttt: 'Sind Sie sicher, dass Sie die Automatisierung aktivieren',
    sureDisableIfttt: 'Sind Sie sicher, dass Sie die Automatisierung deaktivieren',
    useIftttTip: `Nach Aktivierung der Automatisierung werden Timing, Zeitplan, Rhythmus, konstante Beleuchtung und Automatisierung des aktuellen Bereichs aktiviert.`,
    disableIftttTip: 'Nach Deaktivierung der Automatisierung werden Timing, Zeitplan, Rhythmus, konstante Beleuchtung und Automatisierung des aktuellen Bereichs deaktiviert',
    needChangeGateway: 'Entschuldigung! Diese Smart-Connect-Box unterstützt die Funktion "Toggle Off/On" nicht. Wenn Sie diese Funktion nutzen möchten, wechseln Sie bitte zu einer kompatiblen Connect-Box.',
    needUpdateGateway: 'Bitte aktualisieren Sie zuerst die Firmware, dann können Sie die Funktion "Toggle Off/On" verwenden.',
    sensorTemplate: 'Sensorvorlage',
    panelTemplate: 'Panelvorlage',
    scheduledSequence: 'Zeitplansequenz',
    loopSequence: 'Schleifensequenz',
    actionItem: 'Ausführungselement',
    pleaseAddOneActionItem: 'Bitte mindestens ein Ausführungselement hinzufügen',
    addScheduledSequenceItem: 'Zeitplansequenzelement hinzufügen',
    sunriseSunset: 'Sonnenauf-/untergang',
    pleaseAddOneSequenceStep: 'Bitte mindestens einen Zeitplansequenzschritt hinzufügen',
    eachStepNeedsActionItem: 'Jeder Zeitplansequenzschritt benötigt mindestens ein Ausführungselement',
    absoluteTime: 'Absolute Zeit',
    relativeDelay: 'Relative Verzögerung',
    effectiveCount: 'Wirksame Anzahl',
    repeatLoop: 'Wiederholungsschleife',
    customLoopCount: 'Benutzerdefinierte Schleifenanzahl',
    times: 'Mal',
    supportSunriseSunsetOffset: 'Unterstützt 0–240 Minuten vor/nach Sonnenauf-/untergang',
    selectSunriseSunset: 'Sonnenauf-/untergang auswählen',
    associatedDateSettings: 'Zugehörige Datumseinstellungen',
    weekly: 'Wöchentlich',
    monthly: 'Monatlich',
    yearly: 'Jährlich',
    supplementalLighting: 'Zusatzbeleuchtung',
    slTimeOverlapTip: 'Zeiträume dürfen sich nicht überschneiden; Einheit natürliches Licht: μmol/m²·s',
    slAddStrategy: '+ Neue Strategie',
    slEmptyStrategy: 'Keine Strategien. Klicken Sie auf „Neue Strategie“',
    slStrategyName: 'Strategiename',
    slStrategyType: 'Strategietyp',
    slLampSwitchStatus: 'Lampenstatus',
    slTargetBrightnessPpfd: 'Zielhelligkeit | PPFD',
    slTargetLightPpfd: 'Ziellicht (PPFD)',
    slIsEnabled: 'Aktiviert',
    slNewStrategy: 'Neue Strategie',
    slEditStrategy: 'Strategie bearbeiten',
    slStrategyNameLabel: 'Strategiename:',
    slStrategyCondition: 'Strategiebedingungen',
    slExecuteAction: 'Ausführungsaktionen',
    slNaturalLightMin: 'Natürliches Licht Min.:',
    slNaturalLightMax: 'Natürliches Licht Max.:',
    slNaturalLightRangeError: 'Die Untergrenze für natürliches Licht muss kleiner als die Obergrenze sein',
    slDelayLightOn: 'Verzögertes Einschalten',
    slDelayLightOnTip: 'Nach dem Einschalten steigt die Helligkeit schrittweise von 0 % bis zur Zielhelligkeit. Das System dimmt in mehreren Stufen gemäß dem Anpassungsintervall und der Gesamtzahl der Anpassungen, bis der Zielwert erreicht ist.',
    slAdjustInterval: 'Anpassungsintervall:',
    slAdjustCount: 'Anpassungsanzahl:',
    slTargetBrightness: 'Zielhelligkeit:',
    slTargetLight: 'Ziellicht:',
    slTimeOrderError: 'Startzeit und Endzeit dürfen nicht gleich sein',
    slTimeOverlapError: 'Zeiträume überschneiden sich. Bitte vor dem Speichern anpassen',
    slDelayAdjustDurationError: 'Anpassungsintervall × (Anzahl - 1) darf die Strategiedauer nicht überschreiten',
    slCrossDay: ' (über Mitternacht)',
    slApplying: 'Strategie wird angewendet…',
    slCreating: 'Wird erstellt…',
    slSaving: 'Wird gespeichert…',
    slStrategyPrefix: 'Strategie',
    slTypeStaticTimed: 'Statisch (zeitgesteuert)',
    slTypeStaticNatural: 'Statisch (Zeit + natürliches Licht)',
    slTypeDynamic: 'Dynamisch',
    slAreaAnchor: 'Bereichsanker (μmol/m²·s)',
    slAreaAnchorTip: 'Volllicht-Anker zur Umrechnung von Helligkeit % in PPFD: PPFD = Bereichsanker × Helligkeit %',
    slArtificialDli: 'Künstliches DLI (mol/m²·d):',
    slNaturalDli: 'Natürliches DLI (mol/m²·d):',
    slCumulativeDli: 'Kumuliertes DLI (mol/m²·d):',
    slTurnOffWhenMet: 'Ausschalten bei erfüllter Bedingung',
    slTimelineCover: '24H-Abdeckung',
    slSelectAreaLeft: 'Bitte zuerst links einen Bereich wählen',
    slCompleteStrategy: 'Bitte Strategieinformationen vollständig ausfüllen',
    slConfirmDelete: 'Diese Strategie löschen?',
    slDisabled: 'Deaktiviert',
  },
  iftttset: {
    noSimultaneously: 'Kann nicht gleichzeitig ausgeführt werden',
    rename: 'Rename',
    isOccupied: 'Folgende Geräte wurden mit $$ konfiguriert,Die Gruppensteuerungsfunktion kann nicht verwendet werden.',
    or: 'oder',
    Mon: 'Mo',
    Tues: 'Di',
    Wed: 'Mi',
    Thur: 'Do',
    Fri: 'Fr',
    Sat: 'Sa',
    Sun: 'So',
    doifttt: 'Machen Sie ein ifttt',
    doswitchifttt: 'EIN/AUS ifttt',
    doscene: 'Szene',
    device: 'Gerät',
    allcondition: 'Alle Bedingung',
    onecondition: 'Beliebige Bedingung',
    select: 'Wählen Sie',
    allday: 'Tag',
    long: 'Immer',
    noholiday: 'Zusatz zu den Feiertagen',
    baseinfor: 'Info',
    basename: 'Name',
    automationset: 'Automatisierung',
    effectivetime: 'Wenn',
    adddata: 'Hinzufügen',
    if: 'Wenn',
    selectioncriteria: 'Wählen Sie',
    timing: 'Zeitsteuerung',
    handledo: 'Manuell',
    do: 'Do',
    do1: 'Do',
    delay: 'Verzögerung',
    minutes: 'Min',
    scene: 'Szene',
    ifttt: 'Automatisierung',
    switchifttt: 'EIN/AUS ifttt',
    save: 'Speichern',
    back: 'Zurück',
    week: 'Woche',
    time: 'Uhrzeit',
    to: 'An',
    starttime: 'Beginn',
    endtime: 'Ende',
    range: 'Zeitintervall',
    data: 'Daten',
    butholiday: 'Zusatz zu den Feiertagen',
    sure: 'Ja',
    cancle: 'Abbrechen',
    timingset: 'Zeitangaben',
    delayset: 'Verzögern',
    triggerset: 'Auslösen',
    actionset: 'Aktion',
    namewarning: 'Bitte vergeben Sie einen Namen für das ifttt',
    effectivetimewarning: 'Legen Sie die Aktivierungszeit fest',
    conditions: 'Wählen Sie die Bedingung',
    triggerwarning: 'Bitte definieren Sie zuerst Ihre if-Bedingung.',
    actionwarning: 'Bitte definieren Sie zuerst Ihre Do-Bedingung.',
    weekwarning: 'Wählen Sie ein Datum',
    handlewarning: 'Manuelles ifttt kann nicht gelöscht werden',
    nodoiftttwarning: 'ifttt falsch ausführen',
    onehandlewarning: 'Es kann nur eine manuelle ifttt hinzugefügt werden',
    deldevicewarning: 'Löschen Sie zuerst das Gerät und die Zeit',
    candohandlewarning: 'Manuelle ifttt kann nicht gelöscht werden',
    delhandlewarning: 'Bitte löschen Sie zuerst das manuelle ifttt',
    tommrow: 'morgen',
    upmove: 'Nach oben verschieben',
    downmove: 'Nach unten gehen',
    up: 'Nach oben gehen',
    down: 'Nach unten gehen',
    and: 'bis',
    hour: 'Stunde',
    off: 'AUS-Modus',
    on: 'EIN-Betrieb',
    add: 'Automatisierung',
    minus: '- Modus',
    colormode: 'Warm-Modus',
    colorAddmode: 'Warm-Modus',
    colorMinusmode: 'Kalt-Modus',
    closeMode: 'Alle anderen Modi schließen',
    openMode: 'Alle anderen Modi öffnen',
    key1: 'Taste1',
    key2: 'Taste2',
    key3: 'Taste3',
    key4: 'Taste4',
    key5: 'Taste5',
    key6: 'Taste6',
    key7: 'Taste7',
    key8: 'Taste8',
    keyOn: 'TasteEIN',
    keyOff: 'TasteAUS',
    keyAdd: 'Taste+',
    keyMinus: 'Taste-',
    officeMode: 'Tagungsmodus 1',
    speechMode1: 'PPT-Modus 1',
    speechMode2: 'PPT-Betrieb2',
    officeTemplate: 'Büro-Modus',
    chooseTemplate: 'Bitte wählen Sie die Vorlage',
    choose: 'Wählen Sie',
    enterTemplateName: 'Bitte geben Sie den Namen der Vorlage ein',
    havePeople: 'Belegt',
    noPeople: 'Leer',
    illumination: 'Tageslicht-Kontrolle',
    rhythm: 'Zeitplan ',
    second: 'zweite',
    officeAutomation: 'Büroautomation einstellen',
    SelectDelayTime: 'Bitte wählen Sie die Verzögerungszeit',
    SelecTtriggle: 'Es muss mindestens ein Ereignis definiert werden',
    SelecAction: 'Mindestens eine Aktion muss definiert werden',
    SelecTime: 'Wählen Sie die Zeit',
    haveTime: 'Zeit existiert bereits',
    setTiming: 'Sie können nur eine Zeit einstellen',
    setSun: 'Es kann nur ein Sonnenauf-/-untergang eingestellt werden',
    timeOrSunExclusive: 'Zeitplan und Sonnenauf-/-untergang schließen sich gegenseitig aus',
    pleaseAddOneDelayItem: 'Bitte mindestens eine Verzögerung hinzufügen',
    lux: 'Lux',
    times: 's',
    dataStep: 'Synchronisierung',
    ok: 'Sicher',
    cancel: 'Abbrechen',
    info: 'Info',
    delIllumination: 'Sind Sie sicher, dass Sie die Tageslichtszene löschen wollen?',
    delRhythm: 'Bestätigen Sie, dass Sie den Zeitplan löschen möchten?',
    IlluminationDevice: 'Beleuchtungskörper',
    developAutomation: 'Erweiterte Automatisierung',
    deviceMove: 'Belegungsmelder',
    deviceMove1: 'Bewegungssensor',
    alreadydelete: 'wurde bereits gelöscht',
    alreadymove: 'er wurde bereits verschoben',
    repeat: 'Wiederholen Sie',
    every: 'Täglich',
    wordDay: 'Arbeitstag',
    weekEnd: 'Wochenende',
    customize: 'Kundenspezifisch',
    weekTip: 'Bitte wählen Sie den Wiederholungszeitraum',
    timeTip: 'Bitte wählen Sie die Start- und Endzeit',
    dataTip: 'Bitte wählen Sie Start- und Enddatum',
    along: 'Entlang',
    triggershowtotaltip: 'Bitte fügen Sie nicht mehr als #16# Wenn-Bedingungen hinzu',
    actionshowtotaltip: 'Bitte fügen Sie nicht mehr als #32# Do-Bedingungen hinzu',
    triggerandactiontip: 'Bitte fügen Sie nicht mehr als #16# Wenn-Bedingungen und #32# Tun-Bedingungen hinzu.',
    areacontrol: 'Bereichskontrolle',
    SelecArea: 'Mindestens ein Bereich muss definiert werden',
    hcl: 'HCL',
    templateList: 'Liste der Automatisierungsvorlagen',
    holidays: 'Feiertage',
    notHolidays: 'Nicht-Feiertage',
    executeOnlyOnce: 'Nur einmal ausführen',
    executionMode: 'Ausführungsmodus',
    moreSettings: 'Weitere Einstellungen',
    local: 'Lokal',
    cloud: 'Cloud',
    recommendation: 'Empfehlung',
    tip1: 'Lokale Ausführung ist auch im Offline-Modus verfügbar',
    tip2: 'Wenn die lokale Ausführung nicht möglich ist, versuchen Sie, auf die Cloud-Ausführung umzuschalten',
    ifttt3Tip: 'Die folgenden Geräte unterstützen die #Feiertagsfunktion# nicht. Bitte nehmen Sie Anpassungen vor.',
    ifttt3Tip2: 'Die folgenden Geräte unterstützen die Funktion #Feiertagsfunktion# nach dem Upgrade.',
    delayedToggleAutomationSwitchState: 'Verzögere das Umdrehen des Automatisierungsschalterstatus',
    automaticalTurnOnOff: 'Nach #2 Sekunden# automatisch #ausschalten#',
    automationSettings: 'Automatisierungseinstellungen',
    toggleSettings: 'Ein/Aus Umschalttasten-Einstellungen',
    notConfigured: 'Feiertagseinstellungen sind nicht konfiguriert. Bitte gehen Sie zu den Projektdetails, um die Feiertage zuerst zu konfigurieren',
    permissionDenied: 'Es wurde festgestellt, dass Sie nicht über die erforderliche Berechtigung für diese Aktion verfügen. Bitte wenden Sie sich an den Projektmanager/Installateur, um Zugriff zu beantragen.',
    areaName: 'Zimmername',
    gotoConfig: "Zur Konfiguration",
    sunrise: 'Sonnenaufgang',
    sunset: 'Sonnenuntergang',
    dateRange: 'Datumsbereich',
    timingSequenceAction: 'Zeitplansequenzaktion',
    timeSetting: 'Zeitangaben',
    pleaseInputConstantLightIntensityName: 'Bitte geben Sie den Namen der konstanten Beleuchtungsstärke ein',
    noSupportTip: 'Gateway oder Geräteversion zu niedrig, bitte upgraden Sie zuerst',
  },
  lastLight: {
    Illuminance: 'Lux ',
    open: 'Schleife öffnen',
    close: 'Schleife schließen',
    lessthan: 'Weniger als',
    brightness: 'Pegel',
    range: 'Bereich',
    to: 'bis',
    big: 'Mehr als',
    standard: 'Standard',
    warning: 'Warnung: Bitte warten Sie, bis der Sensormesswert stabil ist',
    selectwaring: 'Mindestens ein Gerät auswählen',
    must: 'Mindestens ein Gerät auswählen',
    selectwaring2: 'Wählen Sie das Gerät',
    selectwaring3: 'Bitte geben Sie den Lux-Wert ein',
    selectwaring4: 'Falscher Bereich',
    selectwaring5: 'Falscher Bereich',
    selectwaring6: 'Falscher Bereich'
  },
  otatask: {
    firmware: 'Firmware',
    mainFirmware: 'Haupt-Firmware',
    childFirmware: 'childFirmware',
    latest: 'Neueste',
    upgrading: 'Aktualisierung läuft',
    taskCreateAllName: 'Alle Geräte aktualisieren',
    areaname: 'Bereich',
    canUpgradeingDevice: 'Aufrüstbare Geräte',
    canUpgradeingDevice2: 'Anzahl der für das Upgrade verfügbaren Geräte',
    initiatefail: 'Fail',
    warninginfor: 'Keine',
    waitForupgrade: 'Wartet',
    UpgradeChecking: 'Überprüfen',
    Upgradeing: 'Aufrüsten',
    UpgradeSuccess: 'Erfolgreich',
    taskSuccess: 'Erfolglos',
    UpgradePartSuccess: 'Teilweise Erfolgreich',
    UpgradeDuplicate: 'Dupliziert',
    UpgradeFail: 'Gescheitert',
    taskFail: 'Gescheitert',
    UpgradeConfilct: 'Konflikt',
    UpgradeBusy: 'Beschäftigt',
    UpgradeProjectIdNull: 'Keine Projekt-ID',
    UpgradePasue: 'Pasue',
    info: 'Info',
    stopfail: 'Fehlgeschlagen',
    stopsuccess: 'Erfolg',
    createTime: 'ErstellenZeit',
    startTime: 'StartZeit',
    lastTime: 'LetzteZeit',
    userId: 'Benutzer',
    bysku: 'Nach Typ',
    byarea: 'Nach Bereich',
    devicetype: 'Typ',
    selectedsku: 'Ausgewählte Sku',
    selecteddevice: 'Ausgewähltes Gerät',
    resumeOperate: 'Betrieb fortsetzen',
    taskname: 'Name der Aufgabe',
    taskjuststart: 'Sofortige Ausführung',
    taskCustom: 'Geplante Ausführung',
    createUpgradeTask: 'Upgrade-Aufgabe erstellen',
    createUpgradeTaskTimeTip: 'Diese Upgrade-Aufgabe wird etwa # Minuten dauern. Die Ergebnisse können in der Liste der Upgrade-Aufgabe eingesehen werden',
    taskNameTip: 'Bitte Aufgabenname eingeben',
    finishcontinuecreate: 'Eine andere Aufgabe erstellen',
    taskDeleteTip: 'Sind Sie sicher, dass Sie # Aufgabe löschen wollen?',
    Unicast: 'Unicast',
    byprojectUpgradeStart: 'Alle aktualisieren',
    selected: 'Ausgewählt',
    tasktitlesku: 'Typen',
    tasktitledevice: 'Geräte',
    UpgradeStop: 'Gestoppt',
    taskStop: 'Anhalten',
    nostopupdatetip: 'Die ausgewählten Geräte, die aktualisiert werden sollen, enthalten Geräte, die ab dem Beginn der Aktualisierung nicht mehr angehalten werden können. Nachdem die Aktualisierungsaufgabe abgebrochen wurde, führen diese Geräte die Aktualisierung weiter durch!',
    oparenosametip: 'Der aktuelle Status der ausgewählten Aufgabe ist inkonsistent und kann den Batchbetrieb nicht vereinheitlichen.',
    taskStoppingTip: 'Beenden',
    taskid: 'Aufgaben-ID'
  },
  qrcode: {
    projectsettitle: 'Projektstandort nicht bestimmt!',
    projectsettip: 'Die QR-Code-Erstellung erfordert einen eindeutigen Standort des Projekts, um die Zaunberechtigungen festzulegen',
    projectsetok: 'Einrichten',
    projectsetcancel: 'Nicht festgelegt',
    switchtitle: 'Sind Sie sicher, dass Sie den Zugriff auf den QR-Code deaktivieren wollen?',
    switchtip: 'Nachdem das Zugriffsrecht des QR-Codes geschlossen wurde, können Benutzer, die über diesen QR-Code freigeben, nicht mehr auf diesen Bereich des Projekts zugreifen, und Benutzer, die darauf zugreifen, werden ebenfalls zum Verlassen gezwungen!',
    deltitle: 'Sind Sie sicher, dass Sie den QR-Code löschen wollen?',
    deltip: 'Nach dem Löschen des QR-Codes werden die regionalen Zugriffsrechte geschlossen, die Benutzer, die darauf zugreifen, werden gezwungen, das Projekt zu verlassen, und alle relevanten Informationen werden gelöscht!',
    qrcodetitle: 'Bereich Begrenzung',
    switch: 'Freigabe-Schalter',
    sharearea: 'Bereich freigeben',
    qrcodename: 'Name',
    qrcodenametip: 'Der Name darf nicht leer sein.',
    screenroatetip: 'Für ein besseres Erlebnis, stellen Sie bitte das Telefon / Tablet aufrecht',
    intoloading: 'QR-Code-Kontrollzentrum laden',
    device: 'Gerät',
    areacontrol: 'Bereich',
    scene: 'Schauplatz',
    positionsearchtip: 'Bitte Adresse eingeben',
    position: 'Standort',
    latlon: 'lat-lon',
    latitude: 'Breitengrad',
    longitude: 'Längengrad',
    ableActionTip: 'Der Sharer hat das Zugriffsrecht ausgeschaltet. Wenn Sie Fragen haben, wenden Sie sich bitte an den Administrator!',
    ableTokenTip: 'Die Berechtigung ist ungültig. Wenn Sie ein Problem haben, wenden Sie sich bitte an den Administrator!',
    gpsOpen: 'Positionierung ist offen',
    gpsOpenTip: 'Um Ihre Standortinformationen zu erhalten, öffnen Sie bitte den Standort und erlauben Sie dem Browser, Standortinformationen zu verwenden<br><br>\n        Versuchen Sie Folgendes:<br>\n        1. Bitte schalten Sie den mobilen Standortdienst ein und erlauben Sie dem Browser, die Standortinformationen zu verwenden<br>\n        2. In den Standort-Einstellungen des Browsers ist es allen Websites erlaubt, auf die Standortinformationen zuzugreifen.\n',
    locationserices: 'Standortdienste',
    whileappuse: 'Während der Nutzung der App',
    beyondPositionTip: 'Versuchen Sie Folgendes in der Nähe des Scanbereichs:<br>\n        1. Bitte schalten Sie den mobilen Standortdienst ein und erlauben Sie dem Browser, die Standortinformationen zu verwenden<br>\n        2. In den Standort-Einstellungen des Browsers ist es allen Websites erlaubt, auf die Standortinformationen zuzugreifen.\n',
    changearea: 'Bereich ändern',
    mapnoadresstip: 'Zugehörige Adresse nicht gefunden！',
    createqrcode: 'QrCode erstellen',
    createqrcodetips: 'Sie sind dabei, einen QR-Code zu erstellen, mit dem Sie die Smart Lighting Installation über ein Smartphone steuern können. Bitte beachten Sie, dass es aus Sicherheitsgründen nur möglich ist, die Beleuchtung über diesen QR-Code zu steuern, wenn sich der Benutzer innerhalb von 2 km vom Projektstandort befindet. Daher muss der Nutzer seinen GPS-Standort aktiviert haben und der Webseite erlauben, ihn zu verwenden, um zu überprüfen, ob sich der Nutzer am Projekt befindet.',
    isWXAppTips: 'Bitte öffnen Sie die Seite in Ihrem Standardbrowser',
    pulldownrefresh: 'Zum Aktualisieren nach unten ziehen',
    releaseupdate: 'Loslassen zum Aktualisieren',
    updating: 'Aktualisieren',
    loading: 'Laden...',
    startingGPSpositioning: 'GPS-Positionierung wird gestartet...',
    GPSPositioningInProgress: 'GPS-Positionierung läuft...',
    accuracy: 'Genauigkeit',
    altitude: 'Höhenlage',
    altitudeAccuracy: 'Höhengenauigkeit',
    heading: 'Fahrtrichtung',
    groundSpeed: 'Bodengeschwindigkeit',
    GPSPositioningFailed: 'GPS-Positionierung fehlgeschlagen',
    startingBDPositioning: 'BD-Positionierung wird gestartet...',
    BDPositioningInProgress: 'BD-Positionierung läuft...',
    BDPositioningDataReturned: 'BD-Positionierungsdaten zurückgegeben...',
    BDPpositioning: 'BD-Positionierung',
    BDPositioningFailed: 'BD-Positionierung fehlgeschlagen',
    BDPositioningStartupFailed: 'BD-Positionierung startet fehlgeschlagen'
  },
  home: {
    changeProfessional: 'Erfolgreich gewechselte Profi-Version',
    changeNotProfessional: 'Erfolgreich auf Normalversion umgestellt',
    zoomScaleTip: 'Der Browser ist im Zoom-Modus, das Layout passt möglicherweise nicht auf die Seite. Eine 100%ige Skalierung wird empfohlen.',
    onlineTipsHeaderTitle: 'Offline?',
    onlineTipsDescribe: 'Bitte überprüfen Sie die Internetverbindung. Die Einstellungen werden in der Cloud gespeichert. Eine instabile Internetverbindung kann zu Datenverlusten führen.',
    onlineTipsOKtext: 'Ok',
    allArea: 'Alle Bereich',
    allProject: 'Alle Projekte',
    ruiyi: 'Intelligente Beleuchtung',
    ouxiangjia: 'Intelligentes Zuhause',
    collectTop: 'Top-Sammlungselemente',
    collectOnly: 'Nur meine Favoriten anzeigen'
  },
  base: {
    notice: 'Hinweis',
    sure: 'OK',
    back: 'Zurück',
    cancel: 'Abbrechen',
    deltext: 'Sind Sie sicher, dass Sie löschen wollen?',
    more: 'Mehr',
    delete: 'Löschen',
    transfer: 'Übertragen',
    move: 'Verschieben',
    download: 'Herunterladen',
    export: 'Exportieren',
    import: 'Importieren',
    type: 'Typ',
    state: 'Staat',
    all: 'Alle',
    total: 'Gesamt',
    upStep: 'Zurück',
    nextStep: 'Nächste',
    name: 'Name',
    selectall: 'Alle',
    latestedVersion: 'Aktuellste Version',
    localVersion: 'Lokale Version',
    restart: 'Neustart',
    start: 'Starten',
    pasue: 'Weiter',
    refresh: 'Aktualisieren',
    create: 'erstellen',
    searchKey: 'Schlüssel suchen',
    searchByState: 'Suche nach Status',
    searchByCreateTime: 'Suche nach CreateTime',
    operate: 'Betreiben Sie',
    resetFilter: 'Filter zurücksetzen',
    to: 'Nach',
    startdate: 'Startzeit',
    enddate: 'Endzeit',
    lastWeek: 'Letzte Woche',
    lastMonth: 'Letzter Monat',
    lastThreeMonths: 'Letzte drei Monate',
    details: 'Einzelheiten',
    startingTip: 'Start Doing',
    restartingTip: 'Neustart',
    errorcode: 'Fehlercode',
    search: 'Suche',
    succeed: 'Erfolgreich',
    error: 'Fehler',
    group: 'Gruppe',
    applyFor: 'Anwenden auf',
    noEmpty: 'kann nicht leer sein',
    bind: 'Binden',
    unbind: 'Bindung aufheben',
    redraw: 'Punkt neu zeichnen',
    mobilephonenumber: 'Mobiles Telefon',
    smsverificatoncode: 'Verifizierungs-Code',
    sendverificatoncode: 'Senden',
    sendagain: 'Senden',
    write: 'Schreiben',
    finish: 'Fertigstellen',
    spread: 'Verbreiten',
    modify: 'Ändern',
    notip: 'Keine Tipps',
    detail: 'Ausschnitt',
    save: 'Speichern',
    yes: 'Ja',
    no: 'No',
    skip: 'Überspringen',
    updateTitle: 'Versionshinweise',
    helpCenter: 'Hilfe-Center',
    before: 'Vor',
    after: 'Nach',
  },
  visual: {
    pdfTransFail: 'Die Konvertierung der PDF-Datei ist fehlgeschlagen.',
    sizeMaxFile: `Die Dateiabmessungen dürfen $$1px x $$2px nicht überschreiten.`,
    maxFile: 'Die Dateigröße darf $$mb nicht überschreiten.',
    lightRate: 'Licht einschalten',
    areaRank: 'Regional ranking',
    areaChoose: 'Wählen Sie einen Bereich',
    searchDevicePlaceholder: 'Bitte geben Sie einen Gerätenamen für die Suche ein',
    deviceDetail: 'Gerätedetails',
    childDeviceRelation: 'Topologie der Geräte',
    drawRoom: 'Zeichnungsraum',
    drawArea: 'Bereich Zeichnung',
    pic: 'Bilder',
    maxNumPic: 'Laden Sie bis zu 10 Bilder hoch',
    maxSizePic: 'Die Bildgröße darf nicht größer als 10000*10000px sein.',
    deviceNeedTime: 'Gerät ist noch nicht vollständig geladen',
    lowEnergy: 'Min. Energie',
    highEnergy: 'Maximale Energie',
    upImgAndLook: 'Es sind keine Zeichnungen in diesem Bereich vorhanden. Bitte folgen Sie den nachstehenden Schritten, um Zeichnungen und zugehörige Konfigurationen hinzuzufügen, bevor Sie sie anzeigen.',
    initConfigTip1: 'Derzeit sind keine Zeichnungen für diesen Bereich vorhanden. Bitte fügen Sie zunächst Zeichnungen hinzu, indem Sie die folgenden Schritte ausführen.',
    initConfigTip2: '1. Unterstützt die Bildformate .jpg, .jpeg und .png mit einer Größe von maximal $$1 MB und weniger als $$2px * $$3px.',
    initConfigTip3: `2. Unterstützt das Format .pdf ohne Größenbeschränkung.`,
    regionFrom: 'Bereich',
    isSetNetwork: 'Ob Netzwerkverteilung',
    moreTitle: 'Mehr Status und Gerätebetrieb',
    deviceMore: 'Klicken Sie zur Ansicht',
    bindagin: 'Neuverknüpfung',
    bindingDiologTxt: 'Nur Bereichsrahmen löschen: ',
    bindingDiologTxt1: 'Nur den Bereichsrahmen löschen, Gerätesymbole bleiben erhalten.',
    bindingDiologTxt2: 'Alles löschen: ',
    bindingDiologTxt3: 'Löschen des Bereichs und der Gerätesymbole.',
    bindingDiologBtnTxt: 'Nur Bereichsrahmen löschen',
    bindingDiologBtnTxt1: 'Alles löschen',
    rightBind: 'Rechtsklick zum Binden des Raums',
    monitorUploadImg: 'In diesem Bereich gibt es keine Zeichnungen.',
    toUpload: 'Weiter zum Hochladen',
    currentArea: 'Aktueller Bereich',
    enableIfttt: 'Aktivieren',
    disableIfttt: 'Deaktivieren',
    enableIftttDialogTitle: 'Die folgenden Arten der Automatisierung werden aktiviert, andere Automatisierungen sind davon nicht betroffen!',
    disableIftttDialogTitle: 'Die folgenden Automatisierungsarten werden deaktiviert, andere Automatisierungen sind davon nicht betroffen!',
    useDeviceDailog: 'Geräteliste zur Auswahl verwenden',
    chooseDeviceInMap: 'Auswahl des Grundrisses verwenden',
    cancleAllSelect: 'Alle aufheben',
    selectSameDevice: 'Den gleichen Gerätetyp auswählen',
    chooseSKU: 'Produkttyp auswählen',
    deleteConfirmTxt: 'Nach dem Löschen eines Bereichs werden die ursprünglichen Gerätepositionen in diesem Bereich automatisch aus dem Grundriss entfernt.',
    rebindConfirmTxt: 'Nach der Neuzuteilung eines Bereichs werden die ursprünglichen Standorte der Geräte in diesem Bereich automatisch aus dem Grundriss entfernt.',
    deviceTypes: 'Bitte wählen Sie den Geräteprotokolltyp',
    deleteEquipmentTip1: 'Nur Bereich löschen: Nur das Bereichsfeld löschen, das Gerätesymbol bleibt erhalten<br />Alles löschen: Sowohl den Bereich als auch die Gerätesymbole im Bereich entfernen',
    deleteEquipmentTip2: 'Nur Bereichsfeld löschen',
    deleteEquipmentTip3: 'Alles lösche',
    please: 'Bitte',
    deviceRepeat: 'Gerät ist bereits vorhanden',
    deviceInSelectRoom: 'Das/die Gerät(e) muss/können im ausgewählten Raum platziert werden',
    device: 'Gerät',
    selectRoom: 'Bitte wählen Sie einen Raum',
    deviceListMsg: 'Nachdem der markierte Bereich verknüpft wurde, kann das Gerät in den markierten Bereich gezogen werden.',
    batchMobile: 'Mehrere Geräte verschieben',
    delAreaMsg: 'Sie müssen alle Geräte aus dem markierten Bereich entfernen, bevor Sie sie erneut verbinden. Sind Sie sicher, dass Sie die Geräte entfernen wollen?',
    modify: 'bearbeiten',
    mapBg: 'Kartenhintergrund',
    roomTips: 'Raum-Tag',
    deviceTips: 'Geräte-Tag',
    replace: 'Grundriss ersetzen',
    del: 'Löschen',
    identification: 'Identifizieren',
    bindArea: 'Gebundener Bereich',
    placeBind: 'Bitte binden Sie den Bereich zuerst mit einem Raum',
    closeLight: 'AUS',
    uploadImg: 'Extra Grundriss hochladen',
    imgSize: 'Bildgröße',
    lessThen: 'und weniger als',
    uploading: 'Laden',
    complete: 'Fertigstellen',
    bindAreaSet: 'Einstellungen für den gebundenen Bereich',
    areaPlan: 'Raumplan',
    areaIsBound: 'Der Raum wurde durch andere markierte Bereiche gebunden, bitte heben Sie die Bindung auf, bevor Sie ihn bearbeiten!',
    areaDoNotBind: 'Bereich kann nicht gebunden werden',
    clickInCanvas: 'Bitte versuchen Sie, dieses Gerät auf den Grundriss zu tippen und zu ziehen',
    imgType: 'Unterstützt jpg, jpeg, png Format, die maximale Größe beträgt 5MB',
    noImgType: 'Dieser Dateityp wird nicht unterstützt',
    noImgSize: 'Datei zu groß',
    planarModel: 'Grundrissmodell',
    edtAreaMsg: 'Es gibt noch Geräte in dem Bereich. Bitte entfernen Sie die Geräte vor der Bearbeitung',
    mapIsLoading: 'Loading...',
    selectDevice: 'Wählen Sie',
    scence: 'Szene',
    ifttt: 'Automatisierung',
    ok: 'Bestätigen Sie',
    cancel: 'Abbrechen',
    addScene: 'Szene',
    chooseDeviceGroup: 'Gruppe',
    uifiedControl: 'Kontrolle Alle',
    width: 'Die breite.',
    height: 'Höhe.',
    editBg: 'Plattengröße',
    notice: 'Info',
    sureDelScene: 'Sind Sie sicher, dass Sie löschen wollen?',
    sureDelGroup: 'Sind Sie sicher, dass Sie löschen wollen?',
    delBg: 'Hintergrund löschen',
    noName: 'OPPLE',
    virtualDevice: 'Virtuelle Geräte',
    virtualLibrary: 'Geräteliste',
    areaname: 'Bereich',
    realDevice: 'Echte Geräte',
    floorname: 'Etage',
    virtualPoint: 'Virtueller Bereich',
    rect: 'Rechteckiger Bereich',
    pencil: 'Unregelmäßige Flächen',
    opacity: 'Transparenz',
    bgColor: 'Schwarz/Weiß',
    virtualTips: 'Gerät in den Bereich ziehen und ablegen',
    searchKey: 'Bitte geben Sie den Gerätenamen',
    select: 'wählen',
    zoomScale: 'Skala vergrößern',
    Legend: 'Legende',
    connectDevice: 'Verbundene Geräte',
    backDevice: 'Vorhandene Gerätebibliothek',
    hasMac: 'Virtuelle Geräte mit MAC',
    lightBox: 'Standardartikel - Lichtkasten',
    batchBind: 'Batch Bindung',
    batchNetwork: 'Massenverteilernetz',
    oneKeyConfig: 'Ein-Klick-Versand',
    other: 'der Rest',
    downloadPoint: 'Liste der Punkte herunterladen',
    createStandardProject: 'Erstel von Standardprojekten',
    noNetwork: 'Nicht angeschlossen',
    toUpgrade: 'Wir rüsten sie auf',
    upgradeTip: 'Wenn die folgenden Geräteversionen die Anforderungen nicht erfüllen, aktualisieren Sie sie, bevor Sie versuchen, sie bereitzustellen',
    upgradeTip2: 'Wenn es kein Problem gibt, klicken Sie auf "Gerät ersetzen", geben Sie die MAC-Adresse erneut ein und liefern Sie sie erneut!',
    changeDevice: 'Ersetzen Sie das Gerät',
    sendScene: 'Szenarien werden verschickt',
    sendingScene: 'Die Szene wird geliefert',
    sendSceneSuccess: 'Die Szene wird geliefert',
    sendSceneFail: 'Der Szenenabschnitt schlägt fehl',
    sendIfttt: 'Automatisierte Lieferung',
    sendingIfttt: 'Automatisierte Lieferung ist im Gange',
    sendIftttSuccess: 'Automatisierung ausgegeben',
    sendIftttFail: 'Versagen des Automatisierungsteils',
    sendProgram: 'Programmheft herausgegeben',
    sendingProgram: 'Die Programmliste wird verteilt',
    sendProgramSuccess: 'Die Programmliste wurde verteilt',
    sendProgramFail: 'Der Programmlistenabschnitt ist fehlgeschlagen',
    noBind: 'Ungebunden',
    macError: 'Die MAC-Adresse ist falsch',
    uploadPoint: 'Laden Sie die Punktetabelle hoch',
    pointName: 'Punkt Name',
    remark: 'remark',
    next: 'Nächster',
    networked: 'netzförmig',
    addressNotFilled: 'Adresse nicht ausgefüllt',
    addressRepeat: 'Doppelte Adresse, bitte erneut ausfüllen',
    waitNetwork: 'Wir haben bis mittag zeit, um die pod-station zu erreichen.',
    continueNetwork: 'Verbinde die netze',
    waitNetwork2: 'Warte, bis die ausrüstung ins netz geht',
    gatewayNetwork: 'Lösche das netz mit licht',
    deviceRepeatBind: 'Das Gerät kann nicht wiederholt gebunden werden',
    networkFail: 'Verteilung fehlgeschlagen. Versuchen Sie es später noch einmal.',
    gateway: 'Optische Box Gateway',
    networking: 'Konfigurieren des Netzwerks',
    networkFail2: 'Die fahndung hat nicht funktioniert, bitte ändern sie die adresse Von macs wieder',
    networkFail3: 'Die Gateway-Version muss aktualisiert werden, bitte aktualisieren Sie sie zuerst und konfigurieren Sie dann das Netzwerk',
    networkFail4: 'Bitte klicken Sie auf die Schaltfläche "Bedienung" des Geräts, um den Countdown herunterzuzählen',
    networkFail5: 'Das Gateway wird erfolgreich hinzugefügt, Soft-Reboot in ca. 28 Sekunden, bitte später...',
    networkFail6: 'Wenn es kein Problem gibt, ersetzen Sie bitte das Gerät, geben Sie die MAC-Adresse erneut ein und klicken Sie dann auf "Netzwerkkonfiguration fortsetzen".',
    refreshDevice: 'Aktualisieren der Geräteliste',
    pointNameTip: 'Geben Sie den Punktnamen an',
    networkState: 'Status der Konfiguration',
    bindDeviceTip: '{BindDeviceCount}-Geräte wurden gebunden, {NotBindPointCount}-Punkte wurden nicht gebunden, und es sind {NotBindDeviceCount}-Geräte ungebunden, bitte binden Sie die entsprechenden Punkte und Geräte',
    networkFailTip: 'Fehler beim Konfigurieren des Netzwerks, versuchen Sie es später erneut',
    goToMonitor: 'Gehe zu Überwachen',
    goToInstallation: 'Gehe zu Einrichtung',
    themeChange: 'Thema ändern',
    exit: 'Beenden',
    duplicateMAC: 'Es gibt doppelte Geräte an der gleichen Stelle',
    removeDevice: 'Bitte entfernen Sie das Gerät nicht aus dem Raum.',
    moveIntoTheRoom: 'In den Raum stellen',
    topLeft: 'Oben links',
    topRight: 'Oben rechts',
    Center: 'Mitte',
    bottomLeft: 'Unten links',
    bottomRight: 'Unten rechts',
    deviceClustering: 'Geräte-Clustering'
  },
  sortSelect: {
    type1: 'Sortieren A-Z',
    type2: 'Sortieren Z-A',
    type3: 'Neuestes zuerst sortieren',
    type4: 'Älteste zuerst sortieren'
  },
  hcl: {
    deviceHcl: 'Rhythmus der Geräte',
    chartAllData: 'Daten anzeigen',
    saveTemplate: 'Hinzufügen zu benutzerdefinierten Vorlagen',
    oppleTemplate: 'OPPLE HCL-Vorlagen',
    template: 'Benutzerdefinierte Vorlagen',
    choose: 'Wählen Sie',
    hclType: 'HCL-Modus auswählen',
    argumentType: 'Steuerungsmodus auswählen',
    gradient: 'Glatter Modus',
    jump: 'Stufenmodus',
    lightCCT: 'Helligkeit+CCT',
    onlyLight: 'Helligkeit',
    onlyCCT: 'CCT',
    whichHcl: 'Das Gerät ist in {a} vorhanden ',
    CantHcl: 'Das Gerät unterstützt keine HCL',
    warning: 'Hinweis: Der aktuelle Bereich enthält Geräte, die die HCL-Funktion nicht unterstützen; die Bereichssteuerungsfunktion kann nicht verwendet werden. ',
    warning1: 'Bitte aktualisieren Sie zuerst die Geräte',
    enable: 'Aktivieren',
    unable: 'Deaktivieren ',
    state: 'Status',
    time: 'Zeit',
    number: 'Nein.',
    enabled: 'Aktiviert erfolgreich',
    unabled: 'Deaktiviert',
    perform: 'Smart-Connect-Box',
    useTemplate: 'Anwenden',
    office: 'Büro',
    school: 'Schule',
    factory: 'Industrie',
    naturalLight: 'Sonnenlicht',
    keywords: 'Suchbegriffe eingeben',
    addTime: 'Zeit hinzufügen',
    allHcl: 'Helligkeit + CCT',
    lightHcl: 'Helligkeit',
    CCTHcl: 'CCT',
    hclState: 'Hcl-Status',
    tips: 'Anmerkungen',
    warning2: '1. Beim Ziehen zur Änderung der Farbtemperatur wird die Farbtemperatur-Einstellung der HCL-Automatisierung, zu der das Gerät gehört, unterbrochen, während die Helligkeitseinstellung fortgesetzt wird. <br />2. Beim Ziehen zur Änderung der Helligkeit wird die Helligkeitseinstellung der HCL-Automatisierung, zu der das Gerät gehört, unterbrochen, während die Farbtemperatur-Einstellung fortgesetzt wird. <br />3. Wenn sowohl Helligkeit als auch Farbtemperatur geändert wurden, wird die HCL-Automatisierung, zu der die Geräte gehören, deaktiviert. <br />4. Die HCL-Geräteschnittstelle kann nicht unterbrochen werden.',
    HclConfig: 'HCL-Einstellungen',
    warning3: 'Punkt hinzufügen: Doppelklick auf eine beliebige Stelle der HCL-Kurve.',
    warning4: 'Punkt bearbeiten: Ziehen und Ablegen des Punktes.',
    warning5: 'Punkt löschen: Klicken Sie auf den Punkt und wählen Sie Löschen.',
    warning6: 'Warnung:Der Abstand zwischen zwei Punkten sollte mehr als 1 Stunde betragen.',
    close: 'AUS',
    search: 'Suche',
    introduce: 'einführen',
    type: 'Typ',
    del: 'Löschen',
    all: 'Alle',
    cancle: 'Abbrechen',
    add: 'Hinzufügen',
    set: 'einstellen',
    colorName: 'CCT',
    cardLightCCT: 'HCL Helligkeit & Farbtemperatur',
    cardLight: 'HCL Nur Helligkeit',
    cardCCT: 'HCL Nur Farbtemperatur',
    cardStop: 'HCL AUS',
    editPoint: 'Punkt bearbeiten',
    modify: 'Ändern',
    clear: 'Löschen',
    warning7: 'Es wird empfohlen, die Bereichssteuerungseinstellungen für mehr als 20 Geräte zu verwenden.',
    warning8: 'Bitte geben Sie den Vorlagennamen ein.'
  },
  identify: {
    identify_default: 'Use \\"identify\\" to localize device'
  },
  reset: {
    reset_00010900_step_1: '1、Gateway einschalten.\n2、Netzwerkkabel einstecken: Das Kabel muss Zugang zum Internet haben und die IP-Adresse per DHCP beziehen können.\n3、Falls erforderlich, DALI-Geräte über DA+/DA− verbinden. Eine zusätzliche DALI-Bus-Stromversorgung ist nicht notwendig.',
    reset_00010900_step_1_title: 'Installation des kabelgebundenen Gateways',
    reset_00010900_step_1_check: 'Powered on and connected to the network',
    reset_00010900_step_2: '1、Halten Sie die Taste „Betrieb“ auf der Vorderseite des Gateways länger als 10 Sekunden gedrückt.\n2、Wie in der Abbildung gezeigt, blinkt die grüne Status-LED schnell – das Gateway befindet sich im Neustartmodus.',
    reset_00010900_step_2_title: 'Gateway zurücksetzen',
    reset_00010900_step_2_check: 'Das Gateway wurde zurückgesetzt.',
    reset_00010900_step_3: '1、Wenn die Ethernet-Anzeige nicht leuchtet, überprüfen Sie bitte, ob die Verbindung zwischen dem Ethernet-Kabel und dem Router ordnungsgemäß ist oder ob eine statische IP-Konfiguration erforderlich ist. Wenn eine statische IP-Adresse verwendet wird, folgen Sie bitte den Anweisungen zur Fertigstellung der Einrichtung.\n2、Wenn die Cloud-Anzeige nicht leuchtet, überprüfen Sie bitte, ob der Router Zugriff auf das Internet hat.\n3、Wenn die Statusanzeige orange leuchtet, weist dies auf einen Softwarefehler hin. Bitte gehen Sie zur vorherigen Schritt zurück und versuchen Sie es erneut. Wenn das Problem weiterhin besteht, wenden Sie sich bitte an den Gateway-Anbieter.\n4、Wenn die Statusanzeige rot leuchtet, weist dies auf einen Hardwarefehler hin. Bitte wenden Sie sich an den Gateway-Anbieter.',
    reset_00010900_step_3_title: 'Gateway-Status überprüfen',
    reset_00010900_step_3_check: 'Alle Anzeigeleuchten sind an und grün.',
    reset_00010900_step_4: 'Geben Sie die MAC-Adresse des Gateway-Geräts ein oder scannen Sie den QR-Code auf dem Gerät, um die MAC-Adresse automatisch zu generieren',
    reset_00010900_step_4_title: 'MAC-Adresse eingeben',
    reset_00010900_step_5: 'Bitte drücken Sie die „Bestätigen“-Taste am Gerät und klicken Sie innerhalb von 120 Sekunden nach der Bestätigung auf die Schaltfläche „Weiter“ auf der Seite.',
    reset_00010900_step_5_title: 'Gateway bestätigen',
    reset_00010900_step_5_check: 'Gerät erfolgreich erkannt und bestätigt'
  },
  energyBoard: {
    noMeasuringDevice: 'Es gibt kein Messgerät für diesen Punkt, bitte fügen Sie das Messgerät hinzu und geben Sie dann diesen Konfigurationspunkt ein.',
    energyFixedConfig: 'Konfiguration der Energieverbrauchsquote',
    carbonEmission: 'Konfiguration des Kohlenstoffemissionsfaktors',
    carbonFactor: 'Kohlenstoff-Emissionsfaktor',
    country: 'Land',
    inputByCountry: 'Das aktuelle Land hat den Kohlenstoffemissionsfaktor nicht konfiguriert, bitte geben Sie ihn manuell ein.',
    inputCarbonFactor: 'Manuell eingeben',
    inputManualSelection: 'Manuelle Auswahl',
    inputNumber: 'Bitte geben Sie eine Zahl ein',
    configTips: 'Vergewissern Sie sich, dass alle Geräte im ausgewählten Gebiet mit dem Messgerät verbunden sind, das an dieses Gebiet gebunden ist.',
    energyAndcarbonEmissionsConfig: 'Energieverbrauchsquote/Kohlenstoffemissionen konfigurieren',
    measureDevice: 'Zählung',
    deviceArea: 'Gerät Bereich',
    deviceStatistics: 'Bereich Gerätestatistik',
    timeClickTip: 'Klicken Sie auf das Datum, um die Startzeit zu wählen, und klicken Sie erneut, um die Endzeit zu wählen',
    HVAC: 'HVAC',
    powerConsumption: 'Stromverbrauch',
    otherConsumption: 'Andere Verbräuche',
    showByDay: 'Täglich',
    showByWeek: 'Wöchentlich',
    showByMonth: 'Monatlich',
    showByQuarter: 'Vierteljährlich',
    showByYear: 'Jährlich',
    countrySet: 'Projektland',
    carbonEmissionSet: 'Zuteilung Kohlenstoffemissionsfaktor',
    YOYcurentMonth: 'Letzter Monat',
    energyType: 'Vergleich Typen',
    addareaname: 'Region hinzufügen',
    editareaname: 'Bereich wechseln',
    energyCompare: 'Kontrast',
    energyProportion: 'Anteil der Energie',
    energyTime: 'Zeitleiste',
    season: 'Staffel',
    energyConfig: 'Konfiguration der Parameter',
    energyConfigTips: 'Die Statistik wird wirksam, wenn die aktuellen Parameter konfiguriert sind',
    statistiMonthly: 'Monatlich',
    statistiQuarterly: 'Vierteljährlich',
    statistiYear: 'Jährlich',
    configTime: 'Zeit der Konfiguration',
    configFinish: 'Erfolgreich',
    carbonEmissions: 'CO2-Emissionen',
    lightEnergy: 'Stromverbrauch für Beleuchtung',
    maxEnergy: 'Max',
    minEnergy: 'Min',
    averageEnergy: 'Durchschnittlicher Energieverbrauch',
    maxEnergySavingRate: 'Maximale Energieeinsparungsrate',
    minEnergySavingRate: 'Minimale Energieeinsparungsrate',
    averageEnergySavingRate: 'Einsparungsrate',
    maxCarbonEmissions: 'Maximale Kohlenstoffemissionen',
    minCarbonEmissions: 'Minimale Kohlenstoffemissionen',
    averageCarbonEmissions: 'Durchschnittlicher Kohlenstoffausstoß',
    energy: 'Energieverbrauch',
    energyDesign: 'Vorhersage',
    energyDesign1: 'Vorhersage',
    energySave: 'Gesamt',
    energySaveToytal: 'Gesamt eingesparte',
    actualEnergy: 'Tatsächlicher Energieverbrauch',
    energyBalanceCounting: 'Energieverbrauchsbilanz',
    unit: 'Einheit',
    energyUnit: 'Einheiten des Energieverbrauchs',
    carbonEmissionsUnit: 'Einheiten für Kohlenstoffemissionen',
    currentMonth: 'In diesem Monat',
    currentYear: 'Dieses Jahr',
    currentSeason: 'Dieses Quartal',
    energyRate: 'Energieverbrauchsrate',
    energyComparison: 'Energiever Kontrast',
    remainingEnergy: 'Energieverbrauchsbilanz',
    energySavingRate: 'Energieverbrauch',
    remainingCarbonEmissions: 'CO2-Bilanz',
    carbonFootprint: 'CO2-Fußabdruck',
    sequentialData: 'Monatsvergleich-Daten',
    year_to_yearData: 'Jahresvergleich-Daten',
    graph: 'Diagramme',
    table: 'Tabellen',
    exportTable: 'Berichte exportieren',
    regionTips: 'Vergleich von bis zu 3 Regionen',
    region: 'Region auswählen',
    statistiObject: 'Statistische Objekte',
    statisticalIndex: 'Statistische Auswertung',
    energyStatistics: 'Energieverbrauchsstatistiken',
    quota: 'Fester Betrag',
    statistiArea: 'Statistisches Gebiet',
    energyQuota: 'Quoten für den Energieverbrauch',
    carbonEmissionsQuota: 'CO2 Emissionszertifikate',
    carbonEmissionsAll: 'Kumulative Kohlenstoffemissionen',
    energyAll: 'Gesamt-Energieverbrauch',
    carbonBalanceCounting: 'Countdown der Kohlenstoffemissionsbilanz',
    actualCarbonEmissions: 'Tatsächliche Kohlenstoffemissionen',
    year_to_year: 'Im Vergleich zum Vorjahr',
    curentDay: 'Tag',
    curentWeek: 'Woche',
    curentMonth: 'Monat',
    curentYear: 'Jahr',
    curentSeason: 'Jahreszeit',
    YOYcurentDay: 'Am Vortag',
    YOYcurentYear: 'Das Vorjahr',
    YOYcurentSeason: 'Das Vorquartal',
    staticSum: 'Statistischer Überblick',
    areaComparation: 'Historischer Vergleich',
    areaProportion: 'Regionaler Vergleich',
    max: 'Höchster',
    min: 'Niedrigster',
    onlineTotal: 'Online/Gesamt',
    openTotal: 'Lichter an / Gesamt',
    existSensor: 'Vorhandensein von Beleuchtungsstärkesensoren',
    config: 'Konfiguration',
    statistiObjectConfig: 'Messgerätekonfiguration',
    other: 'Andere',
    pieEnergyListHeader: 'Rangfolge des tatsächlichen Energieverbrauchs nach Gebiet im Vergleich',
    pieEnergyListDes: 'Das Balkendiagramm zeigt die Rangfolge des tatsächlichen Energieverbrauchs des ausgewählten Gebiets in dem ausgewählten Zeitraum.',
    pieEnergyHeader: 'Tatsächlicher Energieverbrauch nach Gebiet',
    pieEnergyDes: 'Das Kreisdiagramm zeigt den tatsächlichen Energieverbrauch des ausgewählten Gebiets im ausgewählten Zeitraum.',
    statisticsNodule: 'Das statistische modul',
    selectStatisticalArea: 'Bitte wählen sie die statistischen bereiche aus',
    selectStatisticalModule: 'Bitte wählen sie das statistische modul',
    exportFailed: 'Exportiert nicht mehr',
    sensorData: 'sensor-angaben',
    prohibitCrossAreaSelection: 'Grenzüberschreitende auswahl ist verboten',
    exportConfigTip1: 'Sachangaben und fehlerstatistiken des geräts können nur echtzeitdaten exportieren',
    exportConfigTip2: 'Die nutzung Von sensor und raumnutzung kann die daten des letzten jahres nur exportieren',
    exportConfigTip3: '(Gesamtzahl der geräte, online-anzahl, offline, störungen und aufgeschlüsselte daten)',
    exportConfigTip4: '(Bewegung, temperatur, luftfeuchtigkeit und grad der feuchtigkeit)',
    exportConfigTip5: '(Indikatoren, regionen/vormonat, regionale prozentanteile)',
    exportConfigTip6: 'Der energieverbrauch entfällt in der regel als anteil aller regionen der unteren kategorie.',
    selectDateRangeTip: 'Der gewählte Zeitraum darf fünf Jahre nicht überschreiten',
    selectDateRangeTip1: 'Der ausgewählte Zeitraum darf 90 Tage nicht überschreiten',
    selectDateRangeTip2: 'Der gewählte Zeitraum darf 12 Monate nicht überschreiten',
    problemFeedback: 'Ein Problem melden',
    questionDescribe: 'Beschreibung',
    describeTip1: 'Bitte beschreiben Sie das aufgetretene Problem oder geben Sie detaillierte Ratschläge',
    describeTip2: 'Bitte geben Sie die Geräte-SKU (8 Bit Hex-Zeichen) ein, die Sie über das Formular Geräteinfo erhalten können.',
    describeTip3: 'Telefonnummer oder E-Mail',
    describeTip4: 'Bitte geben Sie eine gültige Telefonnummer oder E-Mail ein',
    describeTip5: 'Bitte geben Sie alle Informationen an',
    describeTip6: 'Laden Sie eine gültige komprimierte Datei hoch',
    describeTip7: 'Bitte geben Sie die MAC-Adresse des Geräts ein',
    describeTip8: 'Please enter your name',
    deviceInfo: 'Geräte-Infos',
    startTime: 'Issue Start and End Time',
    userInfo: 'Benutzer-Infos',
    userName: 'Name',
    userPhone: 'Kontaktinformationen',
    sureSubmit: 'Senden',
    firstEnergy: "Renovierungseinsparungen",
    secondEnergy: "Intelligente Einsparungen",
    secondEnergyRate: "Intelligente Einsparungsrate",
    firstEnergyRate: "Renovierungseinsparungen Rate",
    firstEnergyV2: "Renovierungseinsparungen (Rate)",
    secondEnergyV2: "Intelligente Einsparungen (Rate)",
    energyMode: "Energieverbrauch (Statistik) Modus",
    designEnergyConsumption: "Vollständige Statistik des geplanten Energieverbrauchs",
    rulesDes: 'Erläuterung der Regeln',
    rulesOpenDes: 'Arbeitszeiten: Erwarteter Gesamtenergieverbrauch = Nennleistung der Leuchten * Anzahl der Leuchten * Arbeitszeiten. Nicht-Arbeitszeiten: Erwarteter Gesamtenergieverbrauch = Nennleistung der Leuchten * Anzahl eingeschalteter Leuchten * Nicht-Arbeitszeiten.',
    rulesCloseDes: 'Erwarteter Gesamtenergieverbrauch an Arbeitstagen = Nennleistung der Leuchten * Anzahl eingeschalteter Leuchten * Licht an Stunden',
    rulesOpenDes1: 'Erwarteter Gesamtenergieverbrauch = Arbeitszeiten + Nicht-Arbeitszeiten',
    rulesOpenDes2: 'Arbeitszeiten = Erwarteter Gesamtenergieverbrauch = Nennleistung der Leuchten * Anzahl der Leuchten * Arbeitszeiten',
    rulesOpenDes3: 'Nicht-Arbeitszeiten =  Erwarteter Gesamtenergieverbrauch = Nennleistung der Leuchten * Anzahl eingeschalteter Leuchten * Nicht-Arbeitszeiten.',
    open: 'WŁĄCZONE',
    closed: 'WYŁĄCZONE',
    infoFrom: "Informacje pochodzą z „Projekt” – „Informacje o kraju” – „Kraj przynależności”",
    infoFrom1: 'Informacje pochodzą z：',
    infoFrom2: 'Projekt – Land Info – Land',
    city: "Stadt",
    building: "Gebäude",
    floor: "Fußboden",
    room: "Zimmer",
    selectAreaType: "${{n}} Gruppe ausgewählt",
    tip1: 'Erläuterung der Daten',
    tip2: 'Erwarteter Energieverbrauch = tatsächlicher Energieverbrauch + eingesparter Energieverbrauch;',
    tip3: 'Eingesparter Energieverbrauch = Energieeinsparung durch Renovierung + intelligente Energieeinsparung;',
    tip4: 'Durchschnittliche Energieeinsparungsrate = eingesparter Energieverbrauch / erwarteter Energieverbrauch;',
    tip5: 'Intelligente Einsparungsrate = (voraussichtlicher Energieverbrauch nach Renovierung – tatsächlicher Energieverbrauch) / voraussichtlicher Energieverbrauch nach Renovierung',
    tip6: 'Einsparungsrate durch Renovierung = (Energieverbrauch vor Renovierung – voraussichtlicher Energieverbrauch nach Renovierung) / Energieverbrauch vor Renovierung',
    noPermissionContactOwner: 'Sie haben derzeit keine Berechtigung, Einstellungen zu ändern. Bitte wenden Sie sich an den Projektinhaber, um diese Funktion zu aktivieren.'
  },
  recycle: {
    dataRecovery: 'Datenwiederherstellung',
    sceneAutomationDeleteTips: 'Szenen und Automationen zeigen vor dem Löschen die verbleibenden Tage, danach werden sie dauerhaft gelöscht',
    restore: 'Wiederherstellen',
    deviceCannotBeEmpty: 'Gerät darf nicht leer sein; dieser Datensatz kann nicht wiederhergestellt werden',
    relatedDeviceDeleted: 'Zugehöriges Gerät wurde gelöscht; Wiederherstellung nicht möglich',
    triggerActionCannotBeEmpty: 'Auslöseaktion darf nicht leer sein; dieser Datensatz kann nicht wiederhergestellt werden',
    executionActionCannotBeEmpty: 'Ausführungsaktion darf nicht leer sein; dieser Datensatz kann nicht wiederhergestellt werden',
    day: 'Tag(e)'
  },
  notices: {
    noticeTimes: 'Benachrichtigungsfrequenz festlegen',
    timeInterval: 'Zeitintervall',
    timeCount1: '15 Minuten',
    timeCount2: '30 Minuten',
    timeCount3: '1 Stunde',
    timeCount4: '12 Stunden',
    timeCount5: '24 Stunden',
    timeInterval_title1: 'Sofortige Benachrichtigung',
    timeInterval_title2: 'Benachrichtigung stündlich nach Gerät',
    timeInterval_title3: 'Benachrichtigung nach Zeit',
    timeInterval_title4: 'Benachrichtigungen stoppen',
    timeInterval_description1: 'Benachrichtigung auslösen, wenn das Gerät seinen Status ändert.',
    timeInterval_description2: 'Unabhängig davon, wie oft das Gerät die Auslösebedingungen erfüllt, wird jedes Gerät nur einmal innerhalb einer Stunde benachrichtigt.',
    timeInterval_description3: 'Innerhalb des eingestellten Intervalls wird jedes Gerät nur einmal benachrichtigt, unabhängig davon, wie oft das Gerät die Auslösebedingungen erfüllt.',
    timeInterval_description4: 'Keine Benachrichtigung, nachdem die Auslösebedingung erfüllt ist',
    subscription_name: 'Name des Abonnements',
    subscription_type: 'Typ des Abonnements',
    sensor_alarm: 'Sensor-Warnungen',
    addSpecifiedDevice: 'Angegebenes Gerät hinzufügen',
    triggerConditions: 'Bedingungen auslösen',
    meetAllSensors: 'Alle Sensoren erfüllen',
    satisfyAnySensor: 'Beliebiger Sensor',
    alarmConfiguration: 'Alarm-Konfiguration',
    notificationObject: 'Benachrichtigungsobjekte',
    auth: 'Berechtigung',
    notifSelf: 'Standardmäßig benachrichtigen',
    specifyUser: 'Bestimmter Benutzer',
    pushUser: 'Push-Benutzer',
    method: 'Art der Mitteilung',
    subscriptionCenter: 'Abonnement-Zentrum',
    allSubscriptions: 'Alle Abonnements',
    addSubscription: 'Abonnement hinzufügen',
    all: 'Alle',
    noticeList: 'Wenn Sie diese Meldung bearbeiten oder löschen möchten, wenden Sie sich bitte an eines der folgenden Konten.',
    know: "Ich hab's",
    checkDelete: 'Bestätigen Sie die Löschung? Diese Aktion ist unwiderruflich!',
    deleteSuccess: 'Löschen erfolgreich',
    watchAll: 'Alle Meldungen anzeigen',
    messageCenter: 'Nachrichtenzentrum',
    sendDate: 'Datum gesendet',
    ownProject: 'Projekt',
    messageDetails: 'Details zur Nachricht',
    processedMan: 'Bearbeiter',
    isHandle: 'Verarbeitet oder nicht',
    processed: 'Verarbeitet',
    notProcessed: 'Unbearbeitet',
    clickHandler: 'Zum Verarbeiten anklicken',
    checkHandler: 'Bestätigen Sie, dass die Nachricht bearbeitet wurde? Diese Aktion kann nicht zurückgenommen werden!',
    readAll: 'Als gelesen markieren',
    processedSuccess: 'Erfolgreich bearbeitet',
    selectDate: 'Datum auswählen',
    markAsProcessed: 'Als bearbeitet markieren',
    readed: 'Gelesen',
    unRead: 'Ungelesen',
    project: 'Artikel',
    systemNotifications: 'System-Benachrichtigung',
    emailNotifications: 'E-Mail-Benachrichtigung',
    messageNotifications: 'SMS-Benachrichtigung',
    appPush: 'App-Benachrichtigung',
    sensor: 'Sensor',
    processingTime: 'Bearbeitungszeit',
    envAlarm: 'Umwelt-Kategorie',
    areaAlarm: 'Regionale Kategorie',
    envAlarmTip: '(Nutzen Sie Sensorendaten als Auslösebedingung. Wenn Umweltveränderungen die festgelegten erfüllen, senden Warnungen/Benachrichtigungen.)',
    areaAlarmTip: '(Pushen Sie in regelmäßigen Abständen Systemdaten, die sich auf den angegebenen Bereich beziehen)',
    noticeByDay: 'Täglicher Push',
    noticeByWeek: 'Wöchentlicher Push',
    noticeByMonth: 'Monatlicher Push',
    pushTime: 'Schiebezeit',
    noticeByDayDescription: '(Einmal am Tag die Daten von gestern pushen)',
    noticeByWeekDescription: '(Tägliche Push-Zeit zum Pushen der Daten der letzten Woche)',
    noticeByMonthDescription: '(Tägliche Push-Zeit, um die Daten des letzten Monats zu pushen)',
    eachMonday: 'jeden Montag',
    eachTuesday: 'jeden Dienstag',
    eachWednesday: 'jeden Mittwoch',
    eachThursday: 'jeden Donnerstag',
    eachFriday: 'jeden Freitag',
    eachSaturday: 'jeden Samstag',
    eachSunday: 'jeden Sonntag',
    pushContent: 'Push-Inhalte',
    temperature: 'Temperatur und Feuchtigkeit',
    faultProportion: 'Prozentsatz der Fehler',
    thirdPartyAccount: 'Persönliche Konten von Dritten',
    thirdPartyGroupAccount: 'Konten von Drittparteien',
    batchImport: 'Stapelimport',
    downloadImportTemplate: 'Importvorlage herunterladen',
    oppleUser: 'OPPLE Benutzer',
    thirdParty: 'Drittnutzer',
    personalAccount: 'persönliches Konto',
    groupAccount: 'Gruppenkonto',
    oppleUserAccount: 'OPPLE Benutzer',
    thirdPartyPersonalAccount: 'Einzelne Nutzer von Dritten',
    thirdPartyGroup: 'Drittparteiengruppe',
    deviceTotal: 'Gesamtzahl der Geräte, Online- und Offline-Daten',
    energyStatistics: 'Tatsächlicher Energieverbrauch, Energieeinsparungen, Energieeinsparungsrate',
    areaTemperature: 'Regionale Temperatur- und Luftfeuchtigkeitsdaten',
    areaFaultProportion: 'Daten über den Prozentsatz der fehlerhaften Geräte in der Region (wie APP - Angaben zu fehlerhaften Geräten)',
    addAccount: 'Konto hinzufügen',
    batchDelete: 'Massenhaftes Löschen',
    importTemplate: 'Vorlagen importieren',
    areaCodeError: 'GpNo ist doppelt vorhanden',
    messagePush: 'Nachrichten-Push',
    pushMethod: 'Push-Methode',
    pushApp: 'Push an die mobile App',
    timeStamp: 'Zeitstempel',
    Day: 'Tag'
  },
  icp: {
    company: 'Suzhou Opple Lighting Co.',
    icpNo: 'Su ICP 13004515',
    networkSecurity: 'Su  öffentliche Netzsicherheitsreserve Nr.32050902100527'
  },
  networkCheck: {
    networkCheck: 'Bewerten Sie die Netzwerkkommunikation für dieses Projekt',
    selectArea: 'Bitte wählen Sie den Bereich aus.',
    cloudServer: 'Cloud-Server',
    normalSubDevice: 'Normale',
    abnormalSubDevice: 'Paketverlustgerät',
    offlineSubDevices: 'Offline',
    weakSignal: 'Das Kommunikationssignal ist schwach',
    linkNotWorking: 'Die Netzwerkkommunikation ist fehlgeschlagen',
    signalDifferenceEquipment: 'Geräte mit schwachem Kommunikationssignal',
    offlineDevice: 'Offline-Geräte',
    unableGateway: 'Unable to complete the linked gateway',
    reset: 'Auf Werkseinstellungen zurücksetzen',
    others: 'Direkt kommunizierende Geräte',
    affectedIfttt: 'Betroffene Automatisierung',
    affectedIftttTip: 'Die Smart Connect Boxes im Automatisierungssystem befinden sich in unterschiedlichen lokalen Netzwerken oder Netzwerksegmenten, was zu Netzwerkunterbrechungen und fehlerhafter Kommunikation führt.',
    serverCloud: 'Cloud-Server',
    signalStrength: 'Signalstärke',
    communicationRate: 'Kommunikationserfolgsrate',
    noGateway: 'Das Projekt ohne Smart Connect Box kann seinen Netzwerkstatus nicht weiter bewerten.',
    notCompatible: 'Verbindung zum Cloud-Server fehlgeschlagen',
    test: 'Bewerten',
    communicationTimes: 'Der Kommunikationsstatus',
    concatIt: 'Bitte wenden Sie sich an die IT-Abteilung',
    deviceList: 'Geräteliste',
    completed: 'Alles abgeschlossen.',
    DetectionTool: 'Tools',
    correspondingGateway: 'Zugehörige Smart Connect Box',
    networkSegment: 'Netzwerksegment',
    waitingToStart: 'Warte auf Start',
    onlyWin: 'Nur für Windows-Systeme unterstützt.',
    toolsTip: 'Verwenden Sie das folgende Werkzeug, um zu überprüfen, ob das aktuelle lokale Netzwerk den Zugriff auf die für die OPPLE-Cloud erforderlichen Domänen und Ports zulässt.',
    smallTool: 'Hilfswerkzeug',
    localAreaNetwork: 'Wenden Sie sich an die IT-Abteilung, um das Netzwerk anzupassen und sicherzustellen, dass sich die entsprechende Smart Connect Box im selben lokalen Netzwerk befindet.',
    status1: 'Wartevorgang',
    status2: 'Überprüfung läuft',
    status3: 'Überprüfung abgeschlossen',
    abnormalCause: 'Abnormalursache',
    solution: 'Lösung',
    normalCommunication: 'Passen Sie die Netzwerkkonfiguration an, um sicherzustellen, dass sich die Gateways im Automatisierungssystem in derselben LAN-Umgebung befinden, um die normale Kommunikation wiederherzustellen.',
    judgmentCriteria: 'Beurteilungskriterien',
    poorCommunication: 'Schlechtes Signal des aktuellen Geräts, Kommunikationserfolgsrate unter $$%',
    indicatorDiagram: 'Anzeigediagramm',
    threeIndicators: 'Die folgenden drei Anzeigen: (1) Systemanzeige, (2) LAN-Anzeige, (3) Cloud-Verbindungsanzeige',
    troubleshootingSteps: 'Fehlerbehebungsschritte',
    step1_v1: '1. Wenn alle drei Anzeigen ausgeschaltet sind, liegt möglicherweise eine ungewöhnliche Stromversorgung oder ein Systemfehler vor. Überprüfen Sie die Stromversorgung oder tauschen Sie die Hardware aus.',
    step2_v1: '2. Wenn die LAN-Anzeige (2) leuchtet und die Cloud-Verbindungsanzeige (3) blinkt, ist der Zugriff auf das externe Netzwerk normal, die Verbindung zur OPPLE-Cloud jedoch fehlerhaft. Überprüfen Sie die lokalen Domänen- und Portbeschränkungen, um sicherzustellen, dass die von OPPLE genutzten Domänen und Ports nicht beschränkt sind.',
    domainLabel: 'Domain Name:',
    portLabel: 'Port:',
    step3_v1: '3. Wenn die LAN-Anzeige (2) leuchtet und die Cloud-Verbindungsanzeige (3) ausgeschaltet ist, kann die Smart Connect Box nicht auf das externe Netzwerk zugreifen. Überprüfen Sie die lokalen Netzwerkbeschränkungen.',
    step4_v1: '4. Wenn die LAN-Anzeige (2) ausgeschaltet ist, erhält die Smart Connect Box keine IP-Adresse. Überprüfen Sie, ob die Netzwerkkabelverbindung ungewöhnlich ist, ob DHCP für die Smart Connect Box beschränkt ist und ob die IP-Konfiguration der Smart Connect Box bei Verwendung einer statischen IP korrekt ist.',
    fourIndicators: 'Die folgenden vier Anzeigen: (1) Statusanzeige, (2) LAN-Anzeige, (3) Internet-Anzeige, (4) WLAN-Anzeige',
    step1_v2: '1. Wenn die Statusanzeige (1) ausgeschaltet ist, liegt möglicherweise eine ungewöhnliche Stromversorgung vor. Überprüfen Sie die Stromversorgung.',
    step2_v2: '2. Wenn die LAN-Anzeige (2), die Internet-Anzeige (3) und die WLAN-Anzeige (4) alle ausgeschaltet sind, liegt möglicherweise ein Systemfehler vor. Tauschen Sie die Hardware aus.',
    step3_v2: '3. Wenn die Internet-Anzeige (3) leuchtet und die WLAN-Anzeige (4) blinkt, ist der Zugriff auf das externe Netzwerk normal, die Verbindung zur OPPLE-Cloud jedoch fehlerhaft. Überprüfen Sie die lokalen Domänen- und Portbeschränkungen, um sicherzustellen, dass die von OPPLE genutzten Domänen und Ports nicht beschränkt sind.',
    officialDomain: 'Offizieller nationaler Cloud-Domänenname (Domänenname je nach Projekt festgelegt; Europa: iotctrl1):',
    step4_v2: '4. Wenn die Internet-Anzeige (3) leuchtet und die WLAN-Anzeige (4) ausgeschaltet ist, kann die Smart Connect Box nicht auf das externe Netzwerk zugreifen. Überprüfen Sie die lokalen Netzwerkbeschränkungen.',
    step5_v2: '5. Wenn die Internet-Anzeige (3) ausgeschaltet ist, erhält die Smart Connect Box keine IP-Adresse. Überprüfen Sie, ob die Netzwerkkabelverbindung ungewöhnlich ist, ob DHCP für die Smart Connect Box beschränkt ist und ob die IP-Konfiguration der Smart Connect Box bei Verwendung einer statischen IP korrekt ist.',
    fourIndicators_v3: 'Vier Indikatoren unten: Systemindikator(1), LAN-Indikator(2), Cloud-Verbindungsindikator(3), WiFi-Indikator(4)',
    step1_v3: '1. Wenn alle vier Indikatoren ausgeschaltet sind, kann dies auf eine abnormale Stromversorgung oder einen Systemfehler zurückzuführen sein. Überprüfen Sie die Stromversorgung oder tauschen Sie die Hardware aus',
    wifiStatusDesc: 'Beschreibung der WLAN-Anzeige (4)',
    wifiOff: 'Ausgeschaltet: WLAN nicht in Betrieb.',
    wifiRedFlash: 'Rot (blinkend): WLAN-SSID oder Passwort nicht konfiguriert.',
    wifiRedOn: 'Rot (dauerhaft leuchtend): Verbindungsversuch mit WLAN (AP).',
    wifiGreenFlash: 'Grün (blinkend): Mit WLAN verbunden, jedoch keine IP-Adresse zugewiesen.',
    wifiGreenOn: 'Grün (dauerhaft leuchtend): Mit WLAN verbunden und IP-Adresse erhalten.',
    issueType: 'Problemtyp',
    correspondingGateway2: 'Zugehörige Smart Connect Box',
    crossNetwork: 'Netzwerksegmentübergreifend',
    crossGateway: 'Smart-Connect-Box-übergreifend'
  },
  controlArea: {
    bindRoomError1: 'Der Drehknopf und einige Leuchten ({names}) befinden sich nicht im selben Gateway. Dimmen ist vorübergehend nicht verfügbar. Bitte verschieben Sie sie in dasselbe Gateway.',
    bindRoomError2: 'Der Drehknopf und alle Leuchten in diesem Raum befinden sich nicht im selben Gateway und können nicht gesteuert werden. Bitte verbinden Sie sie mit demselben Gateway.',
    bindRoomError3: 'In diesem Raum gibt es keine steuerbaren Leuchten. Bitte verschieben Sie den Drehknopf in einen Raum mit Leuchten oder wählen Sie erneut.',
    reSelect: 'Erneut auswählen',
    knew: 'Verstanden',
  },
  ...Locale,
}
export default de
